"use strict";

(function ($) {
    const VERTICAL_ALIGN_BUTTONS = [
        {
            role: 'valignstart',
            attrs: {
                'data-radio': 'vAlign',
            },
            qtip: 'photobook-valign-start',
        },
        {
            role: 'valigncenter',
            attrs: {
                'data-radio': 'vAlign',
            },
            qtip: 'photobook-valign-center',
        },
        {
            role: 'valignend',
            attrs: {
                'data-radio': 'vAlign',
            },
            qtip: 'photobook-valign-end',
        },
    ];

    $.widget("fotobook.containerEditor", {
        TYPE_ARTEFACT: "ARTEFACT",
        TYPE_BG: "BG",
        TYPE_FOTO: "FOTO",
        TYPE_GROUP: "GROUP",
        TYPE_RICHTEXT: "RICHTEXT",
        TYPE_SPINE: "SPINE",
        TYPE_TEXT: "TEXT",
        TYPE_SELECTION: "SELECTION",
        TYPE_FOTOWINDOW: "FOTOWINDOW",
        TYPE_CALENDAR: "CALENDAR",
        textTypes: ["TEXT", "RICHTEXT", "SPINE"],
        // todo сделать панельку в отдельным виджетом, для каждого типа контейнера свой
        controls: {
            "FOTO": [
                {
                    "elements": [
                        {role : "toback", qtip: 'photobook-tooltipText-toback'},
                        {role : "backward", qtip: 'photobook-tooltipText-backward'},
                        {role : "totop", qtip: 'photobook-tooltipText-totop'},
                        {role : "opacity", qtip: 'photobook-tooltipText-opacity'},
                        {role : "swapphotos", qtip: 'photobook-tooltipText-swapPhotos'},
                    ],
                },
                {
                    "elements": [
                        {role : "editgroup", qtip: 'photobook-tooltipText-editgroup'}
                        ],
                    "elements_right": [
                        {role : "contrx", qtip: 'photobook-tooltipText-contrx'},
                        {role : "setshapebyfoto", qtip: 'photobook-tooltipText-setshapebyfoto'},
                        {role : "croppingzoom", qtip: 'photobook-tooltipText-croppingzoom'},
                        {role : "fitquality", qtip: 'photobook-tooltipText-fitquality'},
                    ],
                },
                {
                    "elements": [
                        {role : "rotateleft", qtip: 'photobook-tooltipText-rotateleft'},
                        {role : "rotateright", qtip: 'photobook-tooltipText-rotateright'},
                        {
                            "html" : [
                                '<div class="tb-button tb-framecolor edit-icons-sprite ajax-tooltip"  data-widget="frameColorWidget" data-qtip-selector="photobook-tooltipText-framecolor"></div>',
                            ].join(""),
                        },
                        {role : "strokewidth", qtip: 'photobook-tooltipText-strokewidth'},
                        {role : "framerx", qtip: 'photobook-tooltipText-framerx'},
                    ],
                },
                {
                    "elements": [
                        {role : "addshadow", qtip: 'photobook-tooltipText-addshadow'},
                        {role : "removeshadow", qtip: 'photobook-tooltipText-removeshadow'},
                        {
                            "html" : [
                                '<div class="tb-button tb-shadowcolor edit-icons-sprite ajax-tooltip"  data-widget="shadowColorWidget" data-qtip-selector="photobook-tooltipText-shadowcolor"></div>',
                            ].join(""),
                        },
                        {role : "shadowopacity", qtip: 'photobook-tooltipText-shadowopacity'},
                        {role : "shadowblur", qtip: 'photobook-tooltipText-shadowblur'},
                        {role : "shadowposition", qtip: 'photobook-tooltipText-shadowposition'},
                    ],
                },
                {
                    "classes": "second",
                    "elements": [{role : "origattrs", qtip: 'photobook-tooltipText-origattrs'}],
                    "elements_right": [
                        {role : "delmask", qtip: 'photobook-tooltipText-delmask'},
                        {role : "delframe", qtip: 'photobook-tooltipText-delframe'},
                        {role : "delfoto", qtip: 'photobook-tooltipText-delfoto'},
                        {role : "deletecont", qtip: 'photobook-tooltipText-deletecont'},
                        {role : "close", qtip: 'photobook-tooltipText-close'},
                    ],
                },
            ],
            "FOTOWINDOW": [
                {
                    "elements": [
                        {role : "rotateleft", qtip: 'photobook-tooltipText-rotateleft'},
                        {role : "rotateright", qtip: 'photobook-tooltipText-rotateright'},
                        {role : "croppingzoom", qtip: 'photobook-tooltipText-croppingzoom'},
                    ],
                },
                {
                    "classes": "second",
                    "elements": [{role : "origattrs", qtip: 'photobook-tooltipText-origattrs'}],
                    "elements_right": [
                        {role : "delfoto", qtip: 'photobook-tooltipText-delfoto'},
                        {role: "deletecont",qtip : "photobook-tooltipText-deletecont"},
                        {role : "close", qtip: 'photobook-tooltipText-close'},
                    ],
                },
            ],
            "ARTEFACT": [
                {
                    "elements": [
                        {role : "toback", qtip: 'photobook-tooltipText-toback'},
                        {role : "backward", qtip: 'photobook-tooltipText-backward'},
                        {role : "forward", qtip: 'photobook-tooltipText-forward'},
                        {role : "totop", qtip: 'photobook-tooltipText-totop'},
                        {role : "opacity", qtip: 'photobook-tooltipText-opacity'},
                    ],
                },
                {
                    "elements": [{role : "editgroup", qtip: 'photobook-tooltipText-editgroup'}],
                    "elements_right": [
                        {role : "fitquality", qtip: 'photobook-tooltipText-fitquality'},
                        {role : "flipx", qtip: 'photobook-tooltipText-flipx'},
                        {role : "flipy", qtip: 'photobook-tooltipText-flipy'},
                    ],
                },
                {
                    "elements": [
                        {role : "addshadow", qtip: 'photobook-tooltipText-addshadow'},
                        {role : "removeshadow", qtip: 'photobook-tooltipText-removeshadow'},
                        {
                            "html" : [
                                '<div class="tb-button tb-element tb-shadowcolor edit-icons-sprite ajax-tooltip"  data-widget="shadowColorWidget" data-qtip-selector="photobook-tooltipText-shadowcolor"></div>',
                            ].join(""),
                        },
                        {role : "shadowopacity", qtip: 'photobook-tooltipText-shadowopacity'},
                        {role : "shadowblur", qtip: 'photobook-tooltipText-shadowblur'},
                        {role : "shadowposition", qtip: 'photobook-tooltipText-shadowposition'},
                    ],
                },
                {
                    "classes": "second",
                    "elements": [{role : "origattrs", qtip: 'photobook-tooltipText-origattrs'}],
                    "elements_right": [
                        {role: "deletecont",qtip : "photobook-tooltipText-delartefact"},
                        {role: "close",qtip : "photobook-tooltipText-close"}
                    ],
                },
            ],
            "BG": [
                {
                    "elements_right": [
                        {role : "croppingzoom", qtip: 'photobook-tooltipText-croppingzoom'},
                        {role : "opacity", qtip: 'photobook-tooltipText-opacity'},
                        {role : "editgroup", qtip: 'photobook-tooltipText-editgroup'},
                    ],
                },
                {
                    "classes": "second",
                    "elements": [
                        {role : "origattrs", qtip: 'photobook-tooltipText-origattrs'},
                        {role : "empty", qtip: 'photobook-tooltipText-empty'},
                        {role : "empty", qtip: 'photobook-tooltipText-empty'},
                    ],
                    "elements_right": [
                        {role : "delmask", qtip: 'photobook-tooltipText-delmask'},
                        {role: "delfoto", qtip: "photobook-tooltipText-delbgfoto"},
                        {role: "deletecont", qtip: "photobook-tooltipText-deletebg"},
                        {role: "close", qtip: 'photobook-tooltipText-close'}
                    ],
                },
            ],
            RICHTEXT: [
                {
                    "elements": [
                        {role: "toback", qtip: 'photobook-tooltipText-toback'},
                        {role: "backward", qtip: 'photobook-tooltipText-backward'},
                        {role: "forward", qtip: 'photobook-tooltipText-forward'},
                        {role: "totop", qtip: 'photobook-tooltipText-totop'},
                    ],
                    "elements_right": [
                        {role: "opacity", qtip: 'photobook-tooltipText-opacity'},
                        {role: "editgroup", qtip: 'photobook-tooltipText-editgroup'},
                    ],
                },
                {
                    elements: [
                        ...VERTICAL_ALIGN_BUTTONS,
                    ],
                },
                {
                    "classes": "redactor-tb",
                },
                {
                    "classes": "second",
                    "elements": [{role: "origattrs", qtip: 'photobook-tooltipText-origattrs'}],
                    "elements_right": [
                        {role: "clear", qtip: 'photobook-tooltipText-clear'},
                        {role: "deletecont", qtip: 'photobook-tooltipText-deletecont'},
                        {role: "close", qtip: 'photobook-tooltipText-close'}
                    ],
                },
            ],
            "SPINE": [
                {
                    "elements": [
                        {
                            "html" : [
                                '<div class="ajax-tooltip" data-widget="spineFontFamilyWidget" data-qtip-selector="photobook-tooltipText-fontfamily"></div>',
                                '<div class="tb-size tb-number-input ajax-tooltip" data-widget="spineFontSizeWidget" data-qtip-selector="photobook-tooltipText-fontsize"></div>',
                            ].join(""),
                        },
                        {role: "bold", qtip: 'photobook-tooltipText-bold'},
                        {role: "italic", qtip: 'photobook-tooltipText-italic'},
                        {
                            "role": "alignjustify",
                            "attrs" : {
                                "data-radio": "align",
                            },
                            "qtip": 'photobook-tooltipText-alignjustify'
                        },
                        {
                            "role": "alignleft",
                            "attrs" : {
                                "data-radio": "align",
                            },
                            "qtip": 'photobook-tooltipText-alignleft'

                        },
                        {
                            "role": "aligncenter",
                            "attrs" : {
                                "data-radio": "align",
                            },
                            "qtip": 'photobook-tooltipText-aligncenter'
                        },
                        {
                            "role": "alignright",
                            "attrs" : {
                                "data-radio" : "align",
                            },
                            "qtip": 'photobook-tooltipText-alignright'

                        },
                        {
                            "html" : [
                                '<div class="tb-button tb-forecolor edit-icons-sprite ajax-tooltip" data-widget="spineFontColorWidget" data-qtip-selector="photobook-tooltipText-forecolor"></div>',
                                '<div class="tb-button tb-bgcolor edit-icons-sprite ajax-tooltip" data-widget="spineBackgroundColorWidget" data-qtip-selector="photobook-tooltipText-bgcolor"></div>',
                            ].join(""),
                        },
                        {role: "origattrs", qtip: 'photobook-tooltipText-origattrs'},
                        {role: "clear", qtip: 'photobook-tooltipText-clear'}
                    ],
                },
            ],
            TEXT: [
                {
                    elements: [
                        {role: 'toback', qtip: 'photobook-tooltipText-toback'},
                        {role: 'backward', qtip: 'photobook-tooltipText-backward'},
                        {role: 'forward', qtip: 'photobook-tooltipText-forward'},
                        {role: 'totop', qtip: 'photobook-tooltipText-totop'},
                    ],
                    elements_right: [
                        {role: 'opacity', qtip: 'photobook-tooltipText-opacity'},
                        {role: 'editgroup', qtip: 'photobook-tooltipText-editgroup'},
                    ],
                },
                {
                    elements: [
                        {
                            html: [
                                '<div class="ajax-tooltip" data-widget="plainTextFontFamilyWidget" data-qtip-selector="photobook-tooltipText-fontfamily"></div>',
                                '<div class="tb-number-input tb-size ajax-tooltip" data-widget="plainTextFontSizeWidget" data-qtip-selector="photobook-tooltipText-fontsize"></div>',
                                '<div class="tb-number-input tb-line-height ajax-tooltip" data-widget="plainTextLineHeightWidget" data-qtip-selector="photobook-tooltipText-lineHeight"></div>',
                            ].join(''),
                        },
                    ],
                },
                {
                    elements: [
                        {
                            role: 'alignjustify',
                            attrs: {
                                'data-radio': 'align',
                            },
                            qtip: 'photobook-tooltipText-alignjustify'
                        },
                        {
                            role: 'alignleft',
                            attrs: {
                                'data-radio': 'align',
                            },
                            qtip: 'photobook-tooltipText-alignleft'
                        },
                        {
                            role: 'aligncenter',
                            attrs: {
                                'data-radio': 'align',
                            },
                            qtip: 'photobook-tooltipText-aligncenter'
                        },
                        {
                            role: 'alignright',
                            attrs: {
                                'data-radio': 'align',
                            },
                            qtip: 'photobook-tooltipText-alignright'
                        },
                        ...VERTICAL_ALIGN_BUTTONS,
                        {role: 'bold', qtip: 'photobook-tooltipText-bold'},
                        {role: 'italic', qtip: 'photobook-tooltipText-italic'},
                        {
                            html: [
                                '<div class="tb-button tb-forecolor edit-icons-sprite ajax-tooltip" data-widget="plainTextFontColorWidget" data-qtip-selector="photobook-tooltipText-forecolor"></div>',

                            ].join(''),
                        },
                        {role : 'addshadow', qtip: 'photobook-tooltipText-addshadow'},
                        {role : 'removeshadow', qtip: 'photobook-tooltipText-removeshadow'},
                        {
                            'html' : [
                                '<div class="tb-button tb-element tb-shadowcolor edit-icons-sprite ajax-tooltip"  data-widget="shadowColorWidget" data-qtip-selector="photobook-tooltipText-shadowcolor"></div>',
                            ].join(''),
                        },
                        {role : 'shadowopacity', qtip: 'photobook-tooltipText-shadowopacity'},
                        {role : 'shadowblur', qtip: 'photobook-tooltipText-shadowblur'},
                        {role : 'shadowposition', qtip: 'photobook-tooltipText-shadowposition'},
                    ],
                },
                {
                    classes: 'second',
                    elements: [{role: 'origattrs', qtip: 'photobook-tooltipText-origattrs'}],
                    elements_right: [
                        {role: 'clear', qtip: 'photobook-tooltipText-clear'},
                        {role: 'deletecont', qtip: 'photobook-tooltipText-deletecont'},
                        {role: 'close', qtip: 'photobook-tooltipText-close'},
                    ],
                },
            ],
            "GROUP": [
                {
                    "elements": [
                        {role: "toback", qtip: 'photobook-tooltipText-toback'},
                        {role: "backward", qtip: 'photobook-tooltipText-backward'},
                        {role: "forward", qtip: 'photobook-tooltipText-forward'},
                        {role: "totop", qtip: 'photobook-tooltipText-totop'},
                    ],
                    "elements_right": [
                        {role: "opacity", qtip: 'photobook-tooltipText-opacity'},
                        {role: "ungroup", qtip: 'photobook-tooltipText-ungroup'},
                    ],
                },
                {
                    "classes": "second",
                    "elements": [{role: "origattrs", qtip: 'photobook-tooltipText-origattrs'}],
                    "elements_right": [
                        {role: "deletecont", qtip: 'photobook-tooltipText-deletecont'},
                        {role: "close", qtip: 'photobook-tooltipText-close'},
                    ],
                },
            ],
            "SELECTION": [
                {
                    "elements": [
                        {role: "group", qtip: 'photobook-tooltipText-group'},
                        {role: "selectedtoleft", qtip: 'photobook-tooltipText-selectedtoleft'},
                        {role: "selectedtoright", qtip: 'photobook-tooltipText-selectedtoright'},
                        {role: "selectedtotop", qtip: 'photobook-tooltipText-selectedtotop'},
                        {role: "selectedtobottom", qtip: 'photobook-tooltipText-selectedtobottom'},
                    ],
                },
                {
                    "classes": "second",
                    "elements_right": [
                        {role: "deletecont",qtip: "deleteselection"},
                        {role: "close",qtip: "close"},
                    ],
                },
            ],
            "CALENDAR": [
                {
                    "elements": [
                        {role: "toback", qtip: 'photobook-tooltipText-toback'},
                        {role: "backward", qtip: 'photobook-tooltipText-backward'},
                        {role: "forward", qtip: 'photobook-tooltipText-forward'},
                        {role: "totop", qtip: 'photobook-tooltipText-totop'},
                        {role: "externalDaysVisibility", qtip: 'photobook-tooltipText-externalDaysVisibility'},
                    ],
                },
                {
                    "elements": [
                        {role: "calendarDate", qtip: 'photobook-tooltipText-calendarDate'},
                        {
                            "html" : '<div class="tb-button tb-orientation edit-icons-sprite ajax-tooltip orientation-vertical" data-qtip-selector="photobook-tooltipText-orientation" data-widget="calendarOrientationWidget"></div>',
                        },
                        {
                            "role": "headerMode",
                            "qtip": 'photobook-tooltipText-headerMode',
                            "dropdown": [
                                {
                                    "text": "photobook-js-headerMode-none",
                                    "value": Fotobook.containers.calendar.HEADER_MODE_NONE,
                                },
                                {
                                    "text": "photobook-js-headerMode-topMonthCenter",
                                    "value": Fotobook.containers.calendar.HEADER_MODE_TOP_MONTH_CENTER,
                                },
                                {
                                    "text": "photobook-js-headerMode-topMonthLeftYearRight",
                                    "value": Fotobook.containers.calendar.HEADER_MODE_MONTH_LEFT_YEAR_RIGHT,
                                },
                            ],
                        },
                        {role: "opacity", qtip: 'photobook-tooltipText-opacity'},
                        {role: "editgroup", qtip: 'photobook-tooltipText-editgroup'}
                    ],
                },
                {
                    "elements": [
                        {
                            "role": "calendarNumbersAlignment",
                            "qtip": 'photobook-tooltipText-calendarNumbersAlignment',
                            "dropdown": [
                                {
                                    "classes": "tb-calendarNumbersAlignment-icon-top-left edit-icons-sprite",
                                    "value" : "numbersAlignment",
                                    "data" : {
                                        "widget" : "calendarNumbersAlignment",
                                        "vertical_align": Fotobook.containers.calendar.ALIGN_START,
                                        "horizontal_align" : Fotobook.containers.calendar.ALIGN_START,
                                    }
                                },
                                {
                                    "classes": "tb-calendarNumbersAlignment-icon-top-center edit-icons-sprite",
                                    "value" : "numbersAlignment",
                                    "data" : {
                                        "widget"   : "calendarNumbersAlignment",
                                        "vertical_align": Fotobook.containers.calendar.ALIGN_START,
                                        "horizontal_align" : Fotobook.containers.calendar.ALIGN_CENTER,
                                    }
                                },
                                {
                                    "classes": "tb-calendarNumbersAlignment-icon-top-right edit-icons-sprite",
                                    "value" : "numbersAlignment",
                                    "data" : {
                                        "widget"   : "calendarNumbersAlignment",
                                        "vertical_align": Fotobook.containers.calendar.ALIGN_START,
                                        "horizontal_align" : Fotobook.containers.calendar.ALIGN_END,
                                    }

                                },
                                {
                                    "classes": "tb-calendarNumbersAlignment-icon-center-left edit-icons-sprite",
                                    "value" : "numbersAlignment",
                                    "data" : {
                                        "widget"   : "calendarNumbersAlignment",
                                        "vertical_align": Fotobook.containers.calendar.ALIGN_CENTER,
                                        "horizontal_align" : Fotobook.containers.calendar.ALIGN_START,
                                    }

                                },
                                {
                                    "classes": "tb-calendarNumbersAlignment-icon-center-center edit-icons-sprite",
                                    "value" : "numbersAlignment",
                                    "data" : {
                                        "widget"   : "calendarNumbersAlignment",
                                        "vertical_align": Fotobook.containers.calendar.ALIGN_CENTER,
                                        "horizontal_align" : Fotobook.containers.calendar.ALIGN_CENTER,
                                    }
                                },
                                {
                                    "classes": "tb-calendarNumbersAlignment-icon-center-right edit-icons-sprite",
                                    "value" : "numbersAlignment",
                                    "data" : {
                                        "widget" : "calendarNumbersAlignment",
                                        "vertical_align": Fotobook.containers.calendar.ALIGN_CENTER,
                                        "horizontal_align" : Fotobook.containers.calendar.ALIGN_END,
                                    }
                                },
                                {
                                    "classes": "tb-calendarNumbersAlignment-icon-bottom-left edit-icons-sprite",
                                    "value" : "numbersAlignment",
                                    "data" : {
                                        "widget"   : "calendarNumbersAlignment",
                                        "vertical_align": Fotobook.containers.calendar.ALIGN_END,
                                        "horizontal_align" : Fotobook.containers.calendar.ALIGN_START,
                                    }

                                },
                                {
                                    "classes": "tb-calendarNumbersAlignment-icon-bottom-center edit-icons-sprite icon-bottom-center",
                                    "value" : "numbersAlignment",
                                    "data" : {
                                        "widget" : "calendarNumbersAlignment",
                                        "vertical_align": Fotobook.containers.calendar.ALIGN_END,
                                        "horizontal_align" : Fotobook.containers.calendar.ALIGN_CENTER,
                                    }
                                },
                                {
                                    "classes": "tb-calendarNumbersAlignment-icon-bottom-right edit-icons-sprite",
                                    "value" : "numbersAlignment",
                                    "data" : {
                                        "widget" : "calendarNumbersAlignment",
                                        "vertical_align": Fotobook.containers.calendar.ALIGN_END,
                                        "horizontal_align" : Fotobook.containers.calendar.ALIGN_END,
                                    }
                                },
                            ],
                        },
                        {
                            "role": "dayNamesPosition",
                            "qtip": 'photobook-tooltipText-dayNamesPosition'
                        },
                        {
                            "role": "weekNumbersPosition",
                            "qtip": 'photobook-tooltipText-weekNumbersPosition',
                            "data": {
                                "widget" : "weekNumbersPositionWidget",
                            },
                        },
                        {
                            "html" : '<div class="tb-button edit-icons-sprite ajax-tooltip tb-calendarBorder" data-qtip-selector="photobook-tooltipText-calendarBorder" data-widget="calendarBorderWidget"></div>',
                        },
                        {role: "calendarBorderWidth", qtip: 'photobook-tooltipText-calendarBorderWidth'}
                    ],
                },
                {
                    "elements": [
                        {
                             "html" : [
                                 '<div class="tb-button tb-element tb-calendarFontsGroup tb-popup-window-fonts edit-icons-sprite ajax-tooltip tb-popup" data-widget="popupWidget" data-qtip-selector="photobook-tooltipText-calendarFontsGroup">',
                                    '<div class="calendar-fonts-options">',
                                         '<div class="button-row">',
                                             '<p class="core-text-11 font-option-title">',
                                                t('photobook-tooltipText-fontoptions-calendar-header'),
                                             '</p>',
                                         '</div>',
                                         '<div class="button-row">',
                                             '<div class="ajax-tooltip" data-widget="calendarMonthFontFamilyWidget" data-qtip-selector="photobook-tooltipText-fontoptions-calendar-header"></div>',
                                             '<div class="tb-size tb-number-input tb-number-input ajax-tooltip" data-widget="calendarFontSizeHeaderWidget" data-qtip-selector="photobook-tooltipText-fontoptions-calendar-header"></div>',
                                             '<div class="tb-button edit-icons-sprite ajax-tooltip styleItalic right" data-qtip-selector="photobook-tooltipText-fontoptions-calendar-header" data-widget="calendarHeaderItalicWidget"></div>',
                                             '<div class="tb-button edit-icons-sprite ajax-tooltip styleBold right" data-qtip-selector="photobook-tooltipText-fontoptions-calendar-header" data-widget="calendarHeaderBoldWidget"></div>',
                                         '</div>',
                                         '<div class="button-row">',
                                             '<p class="core-text-11 font-option-title">',
                                                    t('photobook-tooltipText-fontoptions-calendar-regular'),
                                             '</p>',
                                         '</div>',
                                        '<div class="button-row">',
                                             '<div class="ajax-tooltip" data-widget="calendarRegularFontFamilyWidget" data-qtip-selector="photobook-tooltipText-fontoptions-calendar-regular"></div>',
                                             '<div class="tb-size tb-number-input tb-number-input ajax-tooltip" data-widget="calendarFontSizeRegularWidget" data-qtip-selector="photobook-tooltipText-fontoptions-calendar-regular"></div>',
                                             '<div class="tb-button edit-icons-sprite ajax-tooltip styleItalic right" data-qtip-selector="photobook-tooltipText-fontoptions-calendar-regular" data-widget="calendarRegularItalicWidget"></div>',
                                             '<div class="tb-button edit-icons-sprite ajax-tooltip styleBold right" data-qtip-selector="photobook-tooltipText-fontoptions-calendar-regular" data-widget="calendarRegularBoldWidget"></div>',
                                        '</div>',
                                        '<div class="button-row">',
                                             '<p class="core-text-11 font-option-title">',
                                                    t('photobook-tooltipText-fontoptions-calendar-holiday_titles'),
                                             '</p>',
                                        '</div>',
                                        '<div class="button-row">',
                                             '<div class="ajax-tooltip" data-widget="calendarHolidayTitlesFontFamilyWidget" data-qtip-selector="photobook-tooltipText-fontoptions-calendar-holiday_titles"></div>',
                                             '<div class="tb-size tb-number-input ajax-tooltip" data-widget="calendarFontSizeHolidayTitleWidget" data-qtip-selector="photobook-tooltipText-fontoptions-calendar-holiday_titles"></div>',
                                             '<div class="tb-button edit-icons-sprite ajax-tooltip styleItalic right" data-qtip-selector="photobook-tooltipText-fontoptions-calendar-holiday_titles" data-widget="calendarHolidayTitlesItalicWidget"></div>',
                                             '<div class="tb-button edit-icons-sprite ajax-tooltip styleBold right" data-qtip-selector="photobook-tooltipText-fontoptions-calendar-holiday_titles" data-widget="calendarHolidayTitlesBoldWidget"></div>',
                                        '</div>',
                                        '<div class="button-row">',
                                             '<p class="core-text-11 font-option-title">',
                                                    t('photobook-tooltipText-fontoptions-calendar-day_names'),
                                             '</p>',
                                        '</div>',
                                        '<div class="button-row">',
                                             '<div class="ajax-tooltip" data-widget="calendarDayNamesFontFamilyWidget" data-qtip-selector="photobook-tooltipText-fontoptions-calendar-day_names"></div>',
                                             '<div class="tb-size tb-number-input ajax-tooltip" data-widget="calendarFontSizeDayNamesWidget" data-qtip-selector="photobook-tooltipText-fontoptions-calendar-day_names"></div>',
                                             '<div class="tb-button edit-icons-sprite ajax-tooltip styleItalic right" data-qtip-selector="photobook-tooltipText-fontoptions-calendar-day_names" data-widget="calendarDayNamesItalicWidget"></div>',
                                             '<div class="tb-button edit-icons-sprite ajax-tooltip styleBold right" data-qtip-selector="photobook-tooltipText-fontoptions-calendar-day_names" data-widget="calendarDayNamesBoldWidget"></div>',
                                        '</div>',
                                        '<div class="button-row">',
                                             '<p class="core-text-11 font-option-title">',
                                                t('photobook-tooltipText-fontoptions-calendar-week_numbers'),
                                             '</p>',
                                        '</div>',
                                        '<div class="button-row">',
                                             '<div class="ajax-tooltip" data-widget="calendarWeekNumbersFontFamilyWidget" data-qtip-selector="photobook-tooltipText-fontoptions-calendar-week_numbers"></div>',
                                             '<div class="tb-size tb-number-input ajax-tooltip" data-widget="calendarFontSizeWeekNumbersWidget" data-qtip-selector="photobook-tooltipText-fontoptions-calendar-week_numbers"></div>',
                                             '<div class="tb-button edit-icons-sprite ajax-tooltip styleItalic right" data-qtip-selector="photobook-tooltipText-fontoptions-calendar-week_numbers" data-widget="calendarWeekNumbersItalicWidget"></div>',
                                             '<div class="tb-button edit-icons-sprite ajax-tooltip styleBold right" data-qtip-selector="photobook-tooltipText-fontoptions-calendar-week_numbers" data-widget="calendarWeekNumbersBoldWidget"></div>',
                                        '</div>',
                                    '</div>',
                                 '</div>'
                             ].join(''),
                        },
                        {
                            "role": "calendarColors",
                            "qtip": 'photobook-tooltipText-calendarColors',
                            "dropdown": [
                                {
                                    "text": "photobook-js-calendarColors-colorMonth",
                                    "classes": "container-editor-calendar-colors edit-icons-sprite-ba colorpicker-icon",
                                    "data" : {
                                        "widget"   : "calendarColorsMonthTextWidget",
                                        "value"    : "monthColor",
                                    },
                                },
                                {
                                    "text": "photobook-js-calendarColors-colorBorder",
                                    "classes": "container-editor-calendar-colors edit-icons-sprite-ba colorpicker-icon",
                                    "data" : {
                                        "widget"   : "calendarColorsBorderWidget",
                                        "value"    : "borderColor",
                                    },
                                },
                                {
                                    "text": "photobook-js-calendarColors-colorBackground",
                                    "classes": "container-editor-calendar-colors edit-icons-sprite-ba colorpicker-icon",
                                    "data" : {
                                        "widget"   : "calendarColorsNumbersBackgroundWidget",
                                        "value"    : "backgroundColor",
                                    }
                                },
                                {
                                    "text": "photobook-js-calendarColors-colorNumbers",
                                    "classes": "container-editor-calendar-colors edit-icons-sprite-ba colorpicker-icon",
                                    "data" : {
                                        "widget"   : "calendarColorsNumbersTextWidget",
                                        "value"    : "regularColor",
                                    },
                                },
                                {
                                    "text": "photobook-js-calendarColors-colorHolidayDay",
                                    "classes": "container-editor-calendar-colors edit-icons-sprite-ba colorpicker-icon",
                                    "data" : {
                                        "widget"   : "calendarColorsHolidaysTextWidget",
                                        "value"    : "weekendColor",
                                    },
                                },
                                {
                                    "text": "photobook-js-calendarColors-holidayBackgroundColor",
                                    "classes": "container-editor-calendar-colors edit-icons-sprite-ba colorpicker-icon",
                                    "data" : {
                                        "widget"   : "holidayBackgroundColorWidget",
                                        "value"    : "holidayBackgroundColor",
                                    },
                                },
                                {
                                    "text": "photobook-js-calendarColors-dayNameTextColor",
                                    "classes": "container-editor-calendar-colors edit-icons-sprite-ba colorpicker-icon",
                                    "data" : {
                                        "widget"   : "calendarColorsDayNameTextWidget",
                                        "value"    : "dayNameColorText",
                                    },
                                },
                                {
                                    "text": "photobook-js-calendarColors-dayNameBackgroundColor",
                                    "classes": "container-editor-calendar-colors edit-icons-sprite-ba colorpicker-icon",
                                    "data" : {
                                        "widget"   : "calendarColorsDayNameBackgroundWidget",
                                        "value"    : "dayNameColorBackground",
                                    },
                                },
                                {
                                    "text": "photobook-js-calendarColors-colorExternalDay",
                                    "classes": "container-editor-calendar-colors edit-icons-sprite-ba colorpicker-icon",
                                    "data" : {
                                        "widget"   : "calendarColorsExternalTextWidget",
                                        "value"    : "externalColor",
                                    },
                                },
                                {
                                    "text": "photobook-js-calendarColors-weekNumbersColor",
                                    "classes": "container-editor-calendar-colors edit-icons-sprite-ba colorpicker-icon",
                                    "data" : {
                                        "widget"   : "calendarColorsWeekNumbersTextWidget",
                                        "value"    : "weekNumbersColor",
                                    },
                                },
                                {
                                    "text": "photobook-js-calendarColors-weekNumbersBackgroundColor",
                                    "classes": "container-editor-calendar-colors edit-icons-sprite-ba colorpicker-icon",
                                    "data" : {
                                        "widget"   : "calendarColorsWeekNumbersBackgroundWidget",
                                        // todo избавиться от ненужных value
                                        "value"    : "weekNumbersBackgroundColor",
                                    },
                                },
                                {
                                    "text": "photobook-js-calendarColors-numberSecondaryColor",
                                    "classes": "container-editor-calendar-colors edit-icons-sprite-ba colorpicker-icon",
                                    "data" : {
                                        "widget"   : "numberSecondaryColorWidget",
                                        "value"    : "numberSecondaryColor",
                                    },
                                },
                                {
                                    "text": "photobook-js-calendarColors-numberSecondaryColorBackground",
                                    "classes": "container-editor-calendar-colors edit-icons-sprite-ba colorpicker-icon",
                                    "data" : {
                                        "widget"   : "numberSecondaryColorBackgroundWidget",
                                        "value"    : "numberSecondaryColorBackground",
                                    },
                                },
                            ],
                        },
                        {
                            "html" : [
                                '<div class="tb-button tb-element tb-popup-apply-all edit-icons-sprite ajax-tooltip tb-popup" data-widget="popupWidget" data-qtip-selector="photobook-tooltipText-calendar-tooltip-apply_to_all">',
                                    '<div class="apply-calendar-formats-popup">',
                                        '<div class="button-row">',
                                            '<div class="button-row">',
                                                '<p class="core-text-11 apply-calendar-formats-title">',
                                                    t('photobook-tooltipText-calendar-format-apply_to_all'),
                                                '</p>',
                                            '</div>',
                                            '<div class="button-row">',
                                                '<div class="tb-button right tb-fotobook_button fotobook_button neutral-button" data-role="popupclose">',
                                                    t('photobook-js-buttonsCancel'),
                                                '</div>',
                                                '<div class="tb-button right tb-fotobook_button fotobook_button functional-button" data-role="applyCalendarFormatsToAll">',
                                                    t('photobook-js-buttonsDialogOk'),
                                                '</div>',
                                            '</div>',
                                        '</div>',
                                    '</div>',
                                '</div>'
                            ].join(''),
                        }
                    ]
                },
                {
                    "classes": "second",
                    "elements_right": [
                        {role: "deletecont", qtip: "photobook-tooltipText-deleteselection"},
                        {role: "close", qtip: "photobook-tooltipText-close"},
                    ],
                },
            ],
        },
        options: {
            def_size: 14,
            min_size: 1,
            max_size: 99,
        },
        containerId: null,
        toolbar: null,
        group: null,
        page: null,
        withQtip: null,
        edit_mode: '',
// text container specific
        caption: null,
        originalCaption: null,
        lastSavedTextContent: null,
        redactorArea: null,
        saveSpine: false, // todo избавиться, реализовать понятнее
        selectionActive: false,
        toolbarPosition: {
            top: 0,
            left: 0
        },
        richDD: {//dropdown
            obj: null,
            offset: null
        },
        reIcon: {
            width: null,
            height: null
        },

        "getToolbar" : function(){
            return this.toolbar;
        },
// toolbar functions

        //Для того что бы на этапе инициалзиации тулбара не учитывалась ширина одной кнопки. Так как добавление/удаление тени будет одна кнопка точно не видна.
        _renderToolbar_removeshadow: function (data) {
            data.classes = (data.classes || "") + " disabled";
            return this._renderToolbarButton(data);
        },
        _renderToolbar_strokewidth: function (data) {
            var content = ['<div class="slider-name">', t("photobook-js-strokewidth"), '</div>'],
                element = this.element,
                frame = element.find('.set-frame-stroke'),
                sliderValue = frame.attr('data-stroke_width'),
                maxSliderValue = Math.min(frame.attr('data-width'), frame.attr('data-height')) * 0.3;
            content.push(this._renderToolbar__slider({
                "classes": "",
                "min": 0,
                "max": maxSliderValue || 100,
                "step": maxSliderValue ? Math.round(maxSliderValue / 100) : 1,
                "value": sliderValue || 0,
                "role": "strokewidth",
            }));
            data.content = this._renderToolbar__popup(content.join(""));
            data.classes = (data.classes || "") + " tb-popup";
            return this._renderToolbarButton(data);
        },
        _renderToolbar_framerx: function (data) {
            var content = ['<div class="slider-name">', t("photobook-js-framerx"), '</div>'],
                element = this.element,
                frame = element.find('.frame.apply-rx'),
                sliderValue = frame.attr('data-rx');
            content.push(this._renderToolbar__slider({
                "classes": "",
                "min": 0,
                "max": 50,
                "step": 1,
                "value": sliderValue || 0,
                "role": "framerx",
            }));
            data.content = this._renderToolbar__popup(content.join(""));
            data.classes = (data.classes || "") + " tb-popup";
            return this._renderToolbarButton(data);
        },
        _renderToolbar_contrx: function (data) {
            var content = ['<div class="slider-name">', t("photobook-js-contrx"), '</div>'],
                element = this.element,
                mask = element.find('.mask.mask-vector'),
                sliderValue = mask.length ? mask.find('.apply-rx').attr('data-rx') : 0;
            content.push(this._renderToolbar__slider({
                "classes" : "",
                "min"     : 0,
                "max"     : 50,
                "step"    : 1,
                "value"   : sliderValue || 0,
                "role"    : "contrx",
            }));
            data.content = this._renderToolbar__popup(content.join(""));
            data.classes = (data.classes || "") + " tb-popup";
            return this._renderToolbarButton(data);
        },
        _renderToolbar_shadowopacity: function (data) {
            const content = ['<div class="slider-name">', t("photobook-js-shadowopacity"), '</div>'],
                element = this.element,
                isTextContainer = Number(element.attr('data-container-type')) === Fotobook.ContainerType.CAPTION,
                feFlood = isTextContainer ? element : element.find('.apply-flood-opacity');
            let sliderValue;

            if(isTextContainer) {
                sliderValue = parseFloat(new WebColor(feFlood.attr('data-shadow-color')).getAlpha()) * 100;
            } else {
                sliderValue = parseFloat(feFlood.attr('flood-opacity')) * 100;
            }

            content.push(this._renderToolbar__slider({
                "classes": "",
                "min": 0,
                "max": 100,
                "step": 1,
                "value": sliderValue || 0,
                "role": "shadowopacity",
            }));
            data.content = this._renderToolbar__popup(content.join(""));
            data.classes = (data.classes || "") + " tb-popup";
            return this._renderToolbarButton(data);
        },
        _renderToolbar_shadowblur: function (data) {
            var content = ['<div class="slider-name">', t("photobook-js-shadowblur"), '</div>'],
                element = this.element,
                isTextContainer = Number(element.attr('data-container-type')) === Fotobook.ContainerType.CAPTION,
                blur = isTextContainer ? element : element.find('.apply-shadow-blur'),
                sliderValue = parseFloat(blur.attr(isTextContainer ? 'data-shadow-blur' : 'data-blur')) * 1000;

            content.push(this._renderToolbar__slider({
                "classes": "",
                "min": 0,
                "max": 150,
                "step": 1,
                "value": sliderValue || 0,
                "role": "shadowblur",
            }));
            data.content = this._renderToolbar__popup(content.join(""));
            data.classes = (data.classes || "") + " tb-popup";
            return this._renderToolbarButton(data);
        },
        _renderToolbar_shadowposition: function (data) {
            var content = ['<div class="slider-name">', t("photobook-js-shadowposition-x"), '</div>'],
                element = this.element,
                isTextContainer = Number(element.attr('data-container-type')) === Fotobook.ContainerType.CAPTION,
                feOffset = isTextContainer ? element : element.find('.apply-shadow-position'),
                sliderValueX = parseFloat(feOffset.attr(isTextContainer ? 'data-shadow-dx' : 'data-dx')) * 1000,
                sliderValueY = parseFloat(feOffset.attr(isTextContainer ? 'data-shadow-dy' : 'data-dy')) * 1000;

            content.push('<div>');
            content.push(this._renderToolbar__slider({
                "classes": "shadowposition-x",
                "min": -500,
                "max": 500,
                "step": 5,
                "value": sliderValueX || 0,
                "role": "shadowposition",
            }));
            content.push('</div>');
            content.push('<div class="slider-name">', t("photobook-js-shadowposition-y"), '</div>');
            content.push('<div>');
            content.push(this._renderToolbar__slider({
                "classes": "shadowposition-y",
                "min": -500,
                "max": 500,
                "step": 5,
                "value": sliderValueY || 0,
                "role": "shadowposition",
            }));
            content.push('</div>');
            data.content = this._renderToolbar__popup(content.join(""));
            data.classes = (data.classes || "") + " tb-popup";
            return this._renderToolbarButton(data);
        },
        _renderToolbar__slider: function (data) {
            return [
                '<div class="fotobook-range-slider">',
                    '<div class="input-range-slider-slide input-range-slider-minus"></div>',
                    '<div class="input-range-slider {classes}" data-min="{min}" data-max="{max}" data-step="{step}" data-value="{value}" data-role="{role}"></div>',
                    '<div class="input-range-slider-slide input-range-slider-plus"></div>',
                '</div>',
            ].join("").supplant(data);
        },
        _renderToolbar_opacity: function (data) {
            var content = ['<div class="slider-name">', t("photobook-js-opacity"), '</div>'];

            content.push(this._renderToolbar__slider({
                classes: '',
                min: 0,
                max: 100,
                step: 1,
                value: Math.floor(100 * Fotobook.book.getOpacity(this.element[0])),
                role: 'opacity',
            }));
            data.content = this._renderToolbar__popup(content.join(""));
            data.classes = (data.classes || "") + " tb-popup";
            return this._renderToolbarButton(data);
        },
        _renderToolbar_croppingzoom: function (data) {
            var content = ['<div class="slider-name">', t("photobook-js-croppingzoom"), '</div>'];

            content.push(this._renderToolbar__slider({
                "classes": "",
                "min": 33,
                "max": 100,
                "step": 1,
                "value": 30,
                "role": "croppingzoom",
            }));
            data.content = this._renderToolbar__popup(content.join(""));
            data.classes = (data.classes || "") + " tb-popup";
            return this._renderToolbarButton(data);
        },
        _renderToolbar__popup: function (content) {
            var tpl = [
                '<div class="tb-popup-window">',
                    '<div class="edit-icons-sprite tb-button tb-close tb-popup-close" data-role="popupclose"></div>',
                    '{content}',
                '</div>',
            ].join("");

            return tpl.supplant({
                "content": content,
            });
        },
        _renderToolbar_headerMode: function(data){
            var element = this.element,
                defaultValue = element.attr('data-month_name_position');
            return this._renderToolbarDropdown(data, defaultValue);
        },
        _renderToolbar_calendarDate: function (data) {
            var _tpl_content = [
                    '<div class="month-selection-block">',
                    '   {label} :</br>',
                        '<input class="month-selection-alt" data-widget="calendarProjectDate" value="{curDate}">',
                    '</div>',
                ].join("");

            var content = _tpl_content.supplant({
                'label': t('photobook-js-calendarDate-label'),
                'curDate': $.datepicker.formatDate('yy-mm', new Date(Date.parse(this.element.attr('data-calendar_date')))),
            });

            data.content = this._renderToolbar__popup(content);
            data.classes = (data.classes || "") + " tb-popup";

            return this._renderToolbarButton(data);
        },
        _renderToolbar_externalDaysVisibility: function (data) {
            if('calendar' !== Fotobook.book.product_type.code) {
                return;
            }

            var element = this.element,
                colorValue = element.attr('data-numbers_color_external'),
                active = 'transparent' === colorValue ? '' : ' active';
            data.classes = (data.classes || "") + active;

            return this._renderToolbarButton(data);
        },

        _renderToolbar_calendarBorderWidth: function(data) {
            var content = ['<div class="slider-name">', t("photobook-js-calendarBorderWidth"), '</div>'],
                $element = this.element,
                sliderValue = $element.attr("data-border_width"),
                maxSliderValue = Fotobook.containers.calendar.getMaxBorderWidth(this.element);

            content.push(this._renderToolbar__slider({
                "classes": "",
                "min": 0,
                "max": maxSliderValue,
                "step": 1,
                "value": sliderValue || 0,
                "role": data.role,
            }));
            data.content = this._renderToolbar__popup(content.join(""));
            data.classes = (data.classes || "") + " tb-popup";
            return this._renderToolbarButton(data);
        },

        createDataAttributes: function(data){
            var attrs = [];
            for (var i in data){
                if (data.hasOwnProperty(i)){
                    attrs.push(["data-", i.escapeHtml(), '="', data[i].toString().escapeAttr(), '"'].join(""));
                }
            }
            return attrs.join(" ");
        },
        _renderToolbarDropdown: function (data, defaultValue) {
            var element = data.element,
                role = element.role || element,
                qtip = element.qtip || role,
                classes = ["tb-button", "tb-element", "tb-"+role, "edit-icons-sprite"],
                tplDropdown = [
                    // auto-reposition - класс для дропдаунов, обрабатываемых не виджетами (для отличия)
                    '<div class="tb-dropdown-options auto-reposition redactor-dropdown">',
                        '{content}',
                    '</div>',
                ].join(""),
                tplDropdownOption = [
                    '<a class="tb-button tb-element {classes}" data-role="{role}" href="javascript:void(0);" {dataAttributes}>',
                        '{text}',
                    '</a>'
                ].join(""),
                options = [];

            for (var i in data.element.dropdown) {
                var option = data.element.dropdown[i];
                if (typeof option != 'function') {
                    var dataValues = option.data || {};
                    if (option.value !== undefined){
                        dataValues.value = option.value;
                    }
                    options.push(tplDropdownOption.supplant({
                        "text": (option.text ? t(option.text) : ''),
                        "role": role,
                        "classes": (option.classes || '') + ' ' + (defaultValue==dataValues.value ? "active" : ''),
                        "dataAttributes" : this.createDataAttributes(dataValues),
                    }));
                }
            }
            if (role != "empty"){
                classes.push("ajax-tooltip");
            }
            data.class="tb-dropdown";
            data.content =  tplDropdown.supplant({
                "content": options.join(""),
            });

            return '<div class="{classes}" data-qtip-selector="{qtip}" data-role="{role}">{content}</div>'.supplant({
                "classes": classes.join(" "),
                "role": 'dropdown',
                "qtip": qtip,
                "content": data.content || "",
            });
        },
        _renderToolbarElementAttributes: function(data){
            return Object.keys(data.attrs || {}).map(function(key){
                var value = data.attrs[key];
                if (typeof(value) === 'function'){
                    value = value.call(this, data);
                }
                return key + '="' + value.escapeHtml() + '"';
            }).join(" ") + this.createDataAttributes(data.data || {});
        },
        _renderToolbarButton: function (data) {
            var element = data.element,
                role = element.role || element,
                qtip = element.qtip || role,
                classes = ["tb-button", "tb-element", "tb-" + role, "edit-icons-sprite"];

            if (data.right){
                classes.push("right");
            }
            if (role != "empty"){
                classes.push("ajax-tooltip");
            }
            if (data.classes){
                classes.push(data.classes);
            }
            return '<div class="{classes}" data-qtip-selector="{qtip}" data-role="{role}" {attrs}>{content}</div>'.supplant({
                "classes": classes.join(" "),
                "role": role,
                "qtip": qtip,
                "content": data.content || "",
                "attrs": this._renderToolbarElementAttributes(data.element),
            });
        },
        _renderToolbar_row_element: function (element, right) {
            // todo рефакторинг виджета - разукрупнение, выделение отдельных виджетов
            // todo для будущих виджетов необходимо иметь возможность самостоятельно создавать свою вёрстку
            if (element.html){
                return element.html;
            }

            var role = element.role || element,
                fun = "_renderToolbar_" + role;

            if (typeof this[fun] != "function") {
                if (element.dropdown) {
                    fun = "_renderToolbarDropdown"
                } else {
                    fun = "_renderToolbarButton";
                }
            }


            return this[fun]({
                "classes": element.classes || "",
                "element": element,
                "right": right,
                "role": role,
            });
        },
        _renderToolbar_row: function (row) {
            var j,
                r = ['<div class="button-row ', row.classes || "", '">'];
            if (row.elements){
                for (j = 0; j < row.elements.length; j++) {
                    r.push(this._renderToolbar_row_element(row.elements[j]));
                }
            }
            if (row.elements_right){
                for (j = row.elements_right.length - 1; j > -1; j--) {
                    r.push(this._renderToolbar_row_element(row.elements_right[j], true));
                }
            }
            r.push("</div>");
            return r.join("");
        },
        /**
         * Отрисовка элементов всплывающей панели инструментов
         *
         * @returns {*}
         * @private
         */
        _renderToolbar: function(){
            var rows = this.controls[this.edit_mode],
                r = [];

            if (!rows){
                return "";
            }

            for (var i = 0; i < rows.length; i++) {
                r.push(this._renderToolbar_row(rows[i]));
            }
            return r.join("");
        },
        /**
         * Инициализация всплывающей панели инструментов для фото, артефакотв ...
         *
         * @private
         */
        _init_toolbar: function(){
            var widget = this,
                classes = ["editorToolbar", "editorToolbar_" + this.edit_mode],
                selectedContainers = Fotobook.containers.getSelected();

            this.containerId = Number(this.element.attr('data-id'));
            if (this.edit_mode === this.TYPE_SPINE) {
                classes.push("spine");
            }
            this.toolbar = $([
                '<div class="', classes.join(" "), '" animate="flipInY">',
                    '<div class="tb-buttons"></div>',
                '</div>'
            ].join(""));

            // вывод подсказки о возможности выбирать элементы посредством Ctrl
            // показывать только если один контейнер выбран
            // @todo - не работает, пересмотреть подход к отображению
            if (
                Fotobook.store.getters['OnlineEditor/editMode'].code !== Fotobook.EditModeCode.INSTANT &&
                selectedContainers.length < 2 &&
                Fotobook.$cookies.get('qtipShowAutoHints') !== 'false'
            ) {
                this.element.attr("data-qtip-text", t("photobook-js-tooltipText-toolbarSelectTooltip"));
                this.element.addClass('ajax-tooltip');
            }
            this.toolbar.data([this.namespace, this.widgetName, "widget"].join("-"), this);
            if (this._isSpine()) {
                var oldZIndex = $.fn.qtip.zindex,
                    fontSize = 2*parseFloat(this.element.css("fontSize")) + "px"; // FOT-1284
                $.fn.qtip.zindex = 1000;
                $('<div id="spineEditor" class="coloured-border" style="font-size:' + fontSize + '"></div>').html(this.caption).dialog({
                    "title": t("photobook-js-spineEditor"),
                    "modal": false,
                    "resizable": false,
                    "autoOpen": true,
                    "closeOnEscape": false,
                    "width": 480,
                    "height": 200,
                    "position": {
                        "my": "bottom",
                        "at": "bottom",
                        "of": "#bottom-controls",
                    },
                    "dialogClass": "fotobook-dialog spine-editor no-close",
                    "buttons": [
                        {
                            "text" : t("photobook-js-buttonsDialogOk"),
                            "data-role": "commitSpine",
                            "click": function(e){
                                widget.commitSpine();
                            },
                        },
                        {
                            "text" : t("photobook-js-buttonsCancel"),
                            "data-role": "close",
                            "click": function(e){
                                $(this).dialog("close");
                            },
                        },
                    ],
                    close: function(){
                        $(".colorpicker-input").colorpicker("close");
                        widget.destroy();
                        $.fn.qtip.zindex = oldZIndex;
                    },

                });
                this._copySpine();
            }

            this.toolbar.find(".tb-buttons").html(this._renderToolbar());
            if (this.withQtip) {
                this.element.data("qtip").hide();
                this.element.data("qtip").disable(true);
            }

            if (this.edit_mode == this.TYPE_RICHTEXT) {
                this.toolbar.addClass("rich-text");
            }

            if (this.edit_mode == this.TYPE_SPINE) {
                this.toolbar.insertBefore("#spineEditor");
            } else {
                $(".site_content").append(this.toolbar);
            }
            // todo в перспективе сделать кнопки отдельными виджетами
            this.toolbar.find(".tb-calendarDate").on("monthpicker-monthselected", function(event, dateText){
                var dateTextValue = new Date(dateText),
                    selectedMonth = $.datepicker.formatDate('m', dateTextValue)-1,
                    selectedYear = $.datepicker.formatDate('yy', dateTextValue);

                Fotobook.containers.calendar.editor.setCalendarDate(widget.element, selectedMonth, selectedYear);
            });

            this.toolbar.find('.input-range-slider').each(function(){
                widget._updateRangeSlider($(this), widget);
            });

        },

        _updateRangeSlider: function($slider, widget) {
            $slider.slider({
                "value": Math.round($slider.attr("data-value")),
                "min": Math.round($slider.attr("data-min")),
                "max": Math.round($slider.attr("data-max")),
                "step": Math.round($slider.attr("data-step")),
                "create": function (event, ui) {
                    $(this).find(".ui-slider-handle").attr("title", $(this).slider("value"));
                },
                "slide": function (event, ui) {
                    $(ui.handle).attr("title", ui.value);
                    widget["action_" + this.getAttribute("data-role")].call(widget, event, ui);
                },
                "start": function (event, ui) {
                    widget["action_" + this.getAttribute("data-role")].call(widget, event, ui);
                },
                "stop": function (event, ui) {
                    widget["action_" + this.getAttribute("data-role")].call(widget, event, ui);
                }
            });
        },

        _getElementFullRect: function(){
            var rect = {},
                el = this.group[0].getBoundingClientRect();

            rect.top = el.top;
            rect.left = el.left;
            rect.bottom = el.bottom;
            rect.right = el.right;

            if (this.element.hasClass("page-container")) {
                var boxes = this.group.find(".frame-gfx, .ui-rotatable-handle, .ui-resizable-handle");
                boxes.each(function(){
                    if ($(this).css("visibility") != "hidden") {
                        var box = this.getBoundingClientRect();
                        if (box.top < rect.top){
                            rect.top = box.top;
                        }
                        if (box.left < rect.left){
                            rect.left = box.left;
                        }
                        if (box.bottom > rect.bottom){
                            rect.bottom = box.bottom;
                        }
                        if (box.right > rect.right){
                            rect.right = box.right;
                        }
                    }
                });
            }
            rect.width = rect.right - rect.left;
            rect.height = rect.bottom - rect.top;
            return rect;
        },
        _getSelectionRect: function(){
            var left = [], right = [], top = [], bottom = [],
                rect, box;

            $(Fotobook.book.book).find(".pages-wrapper").find(".book-page:not(.flyleaf-page)").each(function(){
                var $this = $(this);
                box = this.getBoundingClientRect()
                top.push(box.top);
                bottom.push(box.bottom);
                left.push(box.left - ($this.hasClass("right") ? parseFloat($this.css("marginLeft")) : 0));
                right.push(box.right + ($this.hasClass("left") ? parseFloat($this.css("marginRight")) : 0));
            });
            box = $(".page-container.selected").boundingRect();
            rect = {
                "top": Math.max(Math.min.apply(this, top), box.top),
                "left": Math.max(Math.min.apply(this, left), box.left),
                "right": Math.min(Math.max.apply(this, right), box.right),
                "bottom": Math.min(Math.max.apply(this, bottom), box.bottom),
            };
            rect.width = rect.right - rect.left;
            rect.height = rect.bottom - rect.top;
            return rect;
        },
        updateToolbarPosition_window: function(){
            var element = this.element,
                toolbar = this.toolbar, instantrect, mainrect, rect, fullrect, page, pageRect,
                arrowSize = 20, toolbar_h, toolbar_w, top, left,
                fullrect_cx,
                fit_bottom, fit_top, fit_left, fit_right, fit_v_left, fit_v_right;
            if (this.edit_mode == this.TYPE_SPINE) {
                return;
            }
            if (!toolbar[0].style.width){
                toolbar.css({
                    "width": toolbar.css("width"),
                    "height": toolbar.css("height"),
                });
            }
            // Если текущий элемент фон и при этом фон разворотный - позиционируем по центру pages-wrapper
            if (this._isBg()) {
                if (Fotobook.book.getSingleOrSpreadBg(element).length > 1) {
                    element = element.closest(".pages-wrapper");
                } else {
                    element = element.closest(".bg");
                }
                fullrect = rect = element[0].getBoundingClientRect();
            } else if (this._isSelection()) {
                fullrect = rect = this._getSelectionRect();
            } else {
                rect = this.group[0].getBoundingClientRect();
                fullrect = this._getElementFullRect();
            }

            instantrect = document.getElementById("instant").getBoundingClientRect();
            mainrect = document.getElementById("main").getBoundingClientRect();
            toolbar_h = toolbar.outerHeight();
            toolbar_w = toolbar.outerWidth();

            // фикс позиции попапа
            // top = fullrect.bottom + arrowSize;
            top = fullrect.bottom - mainrect.top + arrowSize;

            // Заглушка для больших залоченных контейнеров которые используются как фон
            page = element.closest(".book-page");
            if (page.length && element.hasClass("locked") && (element.height() >= page.height())) {
                pageRect = page[0].getBoundingClientRect();
                top = pageRect.bottom + arrowSize;
            }
            left = rect.left + rect.width / 2 - toolbar_w / 2;
            toolbar.removeClass("upper-toolbar left-toolbar right-toolbar");

            fullrect_cx = fullrect.left + fullrect.width / 2;
            fit_bottom = fullrect.bottom < mainrect.bottom;            // Если тулбар помещается ниже нижней границы
            fit_top = fullrect.top - toolbar_h / 2 > instantrect.top;                     // Если тулбар поместится выше
            fit_v_right = fullrect_cx - toolbar_w / 2 > instantrect.left;
            fit_v_left = fullrect_cx + toolbar_w / 2 < instantrect.right;
            fit_right = fullrect.right + toolbar_w + arrowSize < mainrect.right;     // Если тулбар поместится справа
            fit_left = fullrect.left - toolbar_w - arrowSize > mainrect.left;        // Если тулбар поместится слева

            if (fit_bottom && fit_v_left && fit_v_right) {
                //если нет возможности расположить тулбар по-центру - смещаем координаты по горизонтали или по-вертикали
                if (top <= mainrect.top) {
                    top = mainrect.top;
                }
            } else if (fit_top && fit_v_left && fit_v_right) {
                toolbar.addClass("upper-toolbar");
                left = rect.left + rect.width / 2 - toolbar_w / 2;

                // фикс позиции попапа
                // top = fullrect.top - toolbar_h - arrowSize;
                top = fullrect.top - mainrect.top - toolbar_h - arrowSize;

                //если нет возможности расположить тулбар по-центру - смещаем координаты
                if (top >= mainrect.bottom - mainrect.top - toolbar_h / 4) {
                    top = mainrect.bottom - mainrect.top - toolbar_h / 4;
                }
            } else {
                if (fit_right) {
                    left = fullrect.right + arrowSize;
                    top = rect.top + (rect.height - toolbar_h) / 2;
                    toolbar.addClass("right-toolbar");
                    if (left <= mainrect.left) {
                        left = mainrect.left;
                    }
                } else if (fit_left) {
                    left = fullrect.left - toolbar_w - arrowSize;
                    top = rect.top + (rect.height - toolbar_h) / 2;
                    toolbar.addClass("left-toolbar");
                } else {
                    //если тулбар ну никуда не помещается, тогда отображаем его вверху поверх контейнера
                    top = mainrect.top - toolbar_h / 2;
                    left = rect.left + rect.width / 2 - toolbar_w / 2;
                    toolbar.addClass("upper-toolbar");
                }

                //если нет возможности расположить тулбар по-центру - смещаем координаты по горизонтали или по-вертикали
                if (top <= mainrect.top - toolbar_h / 4) {
                    top = mainrect.top - toolbar_h / 4;
                } else if (top > mainrect.bottom - mainrect.top + toolbar_h / 4) {
                    top = mainrect.bottom - mainrect.top + toolbar_h / 4;
                }
            }

            //если залазит на левую панель
            if (left <= mainrect.left - toolbar_w / 2) {
                left = mainrect.left - toolbar_w / 2;
            }

            if (this.edit_mode == this.TYPE_TEXT) {
                toolbar.height(toolbar.height()); // IE11 strange bug with toolbar height
            }

            toolbar.css({
                "top": parseInt(top + (window.scrollY || window.pageYOffset), 10),
                "left": parseInt(left + (window.scrollX || window.pageXOffset), 10),
            }).show();
        },
        updateToolbarPosition_lists: function(){
            var instantrect = document.getElementById("instant").getBoundingClientRect();
            this.toolbar.find(".active .tb-dropdown-options.auto-reposition").each(function(){
                var $dropdown = $(this);

                $dropdown.removeClass("open-to-top").toggleClass("open-to-top", (this.getBoundingClientRect().bottom > instantrect.bottom));
                $dropdown.removeClass("open-to-left").toggleClass("open-to-left", (this.getBoundingClientRect().right > instantrect.right));
            });
            if (this.edit_mode == this.TYPE_RICHTEXT) {
                this.updateRichDdPosition();
            }

        },
        updateToolbarPosition_popups: function(){
            var instantrect = document.getElementById("main").getBoundingClientRect();
            this.toolbar.find(".tb-popup-window:visible").each(function(){
                var $this = $(this).removeClass("left"),
                    rect = this.getBoundingClientRect();
                $this.toggleClass("left", rect.right > instantrect.right);
            });
        },
        updateToolbarPosition_call: function(){
            this.updateToolbarPosition_window();
            this.updateToolbarPosition_lists();
            this.updateToolbarPosition_popups();
            this.toolbar.trigger(Fotobook.events.EDITOR_TOOLBAR_MOVED);
        },
        updateToolbarPosition_queued: false,
        updateToolbarPosition: function(){
            var widget = this;
            if (!this.updateToolbarPosition_queued) {
                widget.updateToolbarPosition_queued = true;
                setTimeout(function(){
                    widget.updateToolbarPosition_queued = false;
                    widget.updateToolbarPosition_call.call(widget);
                }, 0);
            }
        },
        updateRichDdPosition: function(){
            if (this.richDD.obj) {
                if (this.reIcon.width === null || this.reIcon.height === null) {
                    var $reIcon = $('.re-icon');
                    this.reIcon = {
                        width: $reIcon.outerWidth(),
                        height: $reIcon.outerHeight()
                    }
                }
                var $editorRichText = $(".editorToolbar.rich-text"),
                    offsetTop = $editorRichText.offset().top - this.toolbarPosition.top,
                    offsetLeft = $editorRichText.offset().left - this.toolbarPosition.left,
                    richDDTop = this.richDD.offset.top + offsetTop,
                    richDDLeft = this.richDD.offset.left + offsetLeft;
                this.richDD.obj.css('top', richDDTop);
                this.richDD.obj.css('left', richDDLeft);
                var richDDRect = this.richDD.obj.get(0).getBoundingClientRect(),
                    instantRect = document.getElementById("instant").getBoundingClientRect(),
                    totalHeight = richDDTop + richDDRect.height + parseInt($editorRichText.css('padding-top'), 10),
                    totalWidth = richDDLeft + richDDRect.width + parseInt($editorRichText.css('padding-left'), 10);

                this.richDD.obj.css('top',  (instantRect.bottom < totalHeight) ? richDDTop  - this.reIcon.height - richDDRect.height : richDDTop);
                this.richDD.obj.css('left', (instantRect.right < totalWidth)   ? richDDLeft + this.reIcon.width  - richDDRect.width  : richDDLeft);
            }
        },
        checkColorBrightness: function (rgb) {
            //если цвет фона корешка не задан, то в редакторе отображется черный фон
            /*
            var bright = ((rgb.r * 299) + (rgb.g * 587) + (rgb.b * 114)) / 1000;
            $("#spineEditor").css('backgroundColor', bright > 125 ? '#000000' : '#FFFFFF');
            */
        },

        validateTextContainer: function(options){
            return Fotobook.textValidator.validate(this.getTextContainer(), options);
        },

// ------------------------------------------------------------------------------------------------------------------
        _closeOpenLists: function () {
            if (this.edit_mode == this.TYPE_RICHTEXT) {
                this.redactorArea.data("redactor").dropdown.hideAll();
            }
        },
        /**
         * Установить тип используемого элемента(контейнера)
         * @private
         */
        _setType: function () {
            if (this.element.hasClass("artefact-container")) {
                this.edit_mode = this.TYPE_ARTEFACT;
            } else if (this.element.hasClass('calendar-container')) {
                this.edit_mode = this.TYPE_CALENDAR;
            } else if (this.element.hasClass(Fotobook.CONT_SUBTYPE_FOTOWINDOW_CLASS)) {
                this.edit_mode = this.TYPE_FOTOWINDOW;
            } else if (this.element.hasClass("foto-container")) {
                this.edit_mode = this.TYPE_FOTO;
            } else if (this.element.hasClass("bg-content")) {
                this.edit_mode = this.TYPE_BG;
            } else if (this.element.hasClass("group-container")) {
                this.edit_mode = this.TYPE_GROUP;
            } else if (this.element.hasClass("text-container")) {
                if (this.element.hasClass("spine")) {
                    this.edit_mode = this.TYPE_SPINE;
                } else if (Number(this.element.find('.caption').attr('data-type')) === Fotobook.CaptionType.RICH) {
                    this.edit_mode = this.TYPE_RICHTEXT;
                } else {
                    this.edit_mode = this.TYPE_TEXT;
                }
            } else if (this.element.hasClass("pages-wrapper")) {
                this.edit_mode = this.TYPE_SELECTION;
            }
        },
        _isTextEditor: function(){
            return (this.textTypes.indexOf(this.edit_mode) != -1);
        },
        _isSpine: function(){
            return this.edit_mode == this.TYPE_SPINE;
        },
        _isBg: function(){
            return this.edit_mode == this.TYPE_BG;
        },
        _isSelection: function(){
            return this.edit_mode == this.TYPE_SELECTION;
        },
        _create: function(){
            var widget = this;

            this._setType();
            this.withQtip = !!this.element.data("qtip");
            this.group = this.element.closest(".top-level,.bg-content,.pages-wrapper,.spine");

            if (this._isTextEditor()) {
                this.caption = this.element.find(".caption:first");
                var textcontent = this._getTextContent();
                if (this.edit_mode == this.TYPE_RICHTEXT) {
                    this.originalCaption = textcontent.html();
                } else {
                    this.originalCaption = textcontent.outerhtml();
                }
                this.element.removeClass("empty-caption");
            }

            if (!this._isSelection()) {
                $(Fotobook.main).addClass("editing");
                if (this._isBg()) {
                    Fotobook.book.getSingleOrSpreadBg(this.element).addClass("editing");
                } else {
                    $(this.element).add(this.group).add(this.element.closest(".cont-wrapper")).addClass("editing");
                }
            }
            if (!this.group.hasClass("locked") && !this._isSpine() && !this._isBg() && !this._isSelection()) {
                if (Fotobook.store.getters['OnlineEditor/editMode'].code !== Fotobook.EditModeCode.INSTANT) {
                    this.group._fotobookResizable()._fotobookRotatable();
                }
            }
            this._init_toolbar();
            this._setContentEditable();
            this._init_rich_text_editor();
            this.checkTextContainerHeight();
            this.updateToolbarPosition();
            this._checkButtons();
            if (this._isTextEditor()) {
                this.lastSavedTextContent = this._getSaveContent();
            }
            // убирает "мерцание" тектстовой заглушки фотоконтейнера при создании меню
            // Fotobook.book.recalcContainer.call(this.element);
            this.toolbar.trigger(Fotobook.events.EDITOR_TOOLBAR_OPENED, this);
            this.toolbar.find("[data-widget]").each(function(){
                var $this = $(this),
                    widgetName = $this.attr("data-widget");

                if (!$this[widgetName]){
                    console.log("Unknown widget: " + widgetName);
                    return;
                }

                $this[widgetName]({
                    "container" : widget.element,
                    "toolbar" : widget.toolbar,
                    "editorWidget" : widget,
                });
            });
        },

        _getTextContent: function(){
            return this.caption.find('.text-content:first');
        },

        /**
         * Разрешить редактирование контента (ввод текста)
         * @private
         */
        _setContentEditable: function(){
            if (this.edit_mode != this.TYPE_TEXT && !this._isSpine()){
                return;
            }

            var textcontent = this._getTextContent();
            if (!textcontent.attr('contenteditable')) {
// Готовим range - он будет установлен по focus на элементе
                var range = rangy.createRange();
                try {
                    range.selectNodeContents(textcontent[0]);
                } catch (e) {
                }
                range.collapse(false);
                textcontent.attr("contenteditable", true).data("rangy", range);

                // убрал таймаут, т.к. на моб. устройствах фокус не открывалась клавиатура
                // setTimeout(function(){
                    textcontent.focus();
                // }, 0);
            }
        },

        /**
         * Запретить редактирование контента (ввод текста)
         * @private
         */
        _clearContentEditable() {
            if (this.edit_mode === this.TYPE_RICHTEXT) {
                return;
            }
            this._getTextContent().removeAttr('contenteditable');
        },
// Инициализация редактора текстов
        _init_rich_text_editor: function(){
            var widget = this,
                element = widget.element;

            if (widget.edit_mode != widget.TYPE_RICHTEXT){
                return;
            }

            widget.redactorArea = $('<textarea style="height: 100%;width:100%">').insertAfter(element.find('.text-content')).redactor({
                "buttons": ['formatting', 'underline', 'bold', 'italic', 'unorderedlist', 'orderedlist', 'alignment'],
                "cleanOnPaste": true,
                "cleanSpaces": false,
                "convertLinks": false,
                "direction" : "auto",
                "deniedTags": $.Redactor.opts.deniedTags.concat(["a", "applet", "body", "button", "head", "html", "img", "input", "link", "meta", "select", "svg", "table", "tbody", "td", "th", "thead", "tr"]),
                "focus": true,
                "formatting": ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
                "lang": $("html").attr("lang"),
                "linebreaks": true,
                "pastePlainText": false,
                "plugins": ["fontfamily", "fontsize", "fontcolor"],
                "removeComments": true,
                "removeDataAttr": true,
                "replaceDivs": false,
                "replaceTags": [
                    ["i", "em"],
                    ["b", "strong"],
                ],
                "toolbarExternal": ".redactor-tb",
                // Hack for http://bt.web100.com.ua/view.php?id=44853 (added 'LI')
                "alignmentTags": ['P', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'LI', 'DL', 'DT', 'DD', 'DIV', 'TD', 'BLOCKQUOTE', 'OUTPUT', 'FIGCAPTION', 'ADDRESS', 'SECTION', 'HEADER', 'FOOTER', 'ASIDE', 'ARTICLE'],
                "pasteBeforeCallback" : Fotobook.textValidator.richTextBeforePaste,
                "dropCallback" : function(event){
                    Fotobook.textValidator.textContainerDropHandler(event);
                },
                "initCallback": function(){
                    var _this = this,
                        text = widget._getTextContent();

                    this.$box.addClass('redactor-general').css('font-size', (parseFloat(element.find('.text-content').data('font-size')) / Fotobook.book.getBaseFontSize()) + 'em');
                    this.code.set(text.length ? text.html() : "");
                    this.code.startSync();
                    // почему-то для некоторых текстов курсор не ставится в конец, а ставится в начало,
                    // если вызывать без таймаута. Так - работает. Для вебкита нужен тамаут побольше

                    setTimeout(function(){
                        //через setEnd не работает если имееются переносы строки.
                        _this.caret.setOffset(_this.$editor, (text.text().length));
                    }, 200);

                    // редактор запрещает эти события, из-за чего нарушается работа drag'n'drop
                    this.$editor.off("dragover.redactor dragenter.redactor");
                },
                "changeCallback": function(html){
                    this.$editor.trigger(Fotobook.events.REDACTOR_CHANGE, widget);
                    this.$editor.trigger(Fotobook.events.TEXT_CONTAINER_CHANGED);
                },
                "dropdownShowCallback": function(){
                    widget.toolbarPosition = widget.toolbar.position();
                },
                // todo разобраться, что тут делается. Вероятно - вынести в отдельный файл
                "dropdownShownCallback": function (obj, key, button) {
                    const getFloatFromString = function (s) {
                        var regex = /[+-]?\d+\.*\d*/g;
                        if (s && s.length) {
                            var match = s.match(regex);
                            if (match) {
                                return match.map(function (v) {
                                    return parseFloat(v);
                                });
                            } else {
                                return parseInt(s, 10);
                            }
                        }
                    };

                    var el = $((this.selection.getCurrent().nodeType == Node.TEXT_NODE) ? this.selection.getCurrent().parentNode : this.selection.getCurrent()),
                        nodeType = (typeof el[0] != 'undefined') ? el[0].nodeType : Node.ELEMENT_NODE,
                        changed = false,
                        formatting = ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
                        checkFontSize = function (elem) {
                            var fs = getFloatFromString(elem.attr('data-redactor-style')),
                                changed = false;
                            obj.dropdown.find('a').each(function(){
                                if (parseInt($(this).text(), 10) === Math.round(fs * Fotobook.book.BASE_SIZE)) {
                                    $(this).addClass('selected');
                                    changed = true;
                                }
                            });
                            return changed;
                        },
                        checkFontFamily = function($elem){
                            var changed = false,
                                elemFont = Fotobook.store.getters['Fonts/getFontByFamily']($elem.css("font-family"));

                            obj.dropdown.find(".selected").removeClass("selected");
                            if (elemFont){
                                changed = !!obj.dropdown.find(".redactor-dropdown-id-" + elemFont.id).addClass("selected").length;
                            }
                            return changed;
                        },
                        checkAlignment = function(elem){
                            var changed = false;
                            obj.dropdown.find('a').each(function(){
                                var style = elem.css('text-align'),
                                    className = this.className;
                                if (className.match(style)) {
                                    $(this).addClass('selected');
                                    changed = true;
                                }
                            });
                            return changed;
                        },
                        checkFormatting = function(elem){
                            var changed = false,
                                tagName = elem[0].tagName.toLowerCase();
                            obj.dropdown.find('a').each(function(){
                                var className = this.className;
                                if (className.match(tagName)) {
                                    $(this).addClass('selected');
                                    changed = true;
                                }
                            });
                            return changed;
                        };
                    obj.dropdown.find('a').removeClass('selected');
                    if (obj.key === 'fontsize') {
                        if (el.length && nodeType !== Node.TEXT_NODE && el.inlineStyle('font-size')) {
                            changed = checkFontSize(el);
                        } else if (Fotobook.checkParents(el, 'font-size')) {
                            var newEl = Fotobook.checkParents(el, 'font-size');
                            changed = checkFontSize(newEl);
                        }

                        if (!changed) {
                            obj.dropdown.find("a:contains('14px')").addClass('selected');
                        }
                    }
                    if (obj.key === 'fontfamily') {
                        if (el.length && nodeType !== Node.TEXT_NODE && el.inlineStyle('font-family')) {
                            changed = checkFontFamily(el)
                        } else if (Fotobook.checkParents(el, 'font-family')) {
                            var newEl = Fotobook.checkParents(el, 'font-family');
                            changed = checkFontFamily(newEl);
                        }
                        if (!changed) {
                            checkFontFamily($('.redactor-editor'));
                        }
                    }
                    if (obj.key === 'alignment') {
                        if (el.length && nodeType !== Node.TEXT_NODE && el.inlineStyle('text-align')) {
                            changed = checkAlignment(el);
                        } else if (Fotobook.checkParents(el, 'text-align')) {
                            var newEl = Fotobook.checkParents(el, 'text-align');
                            changed = checkAlignment(newEl);
                        }
                        if (!changed) {
                            obj.dropdown.find('a.redactor-dropdown-center').addClass('selected');
                        }
                    }
                    if (obj.key === 'formatting') {
                        if (el.length) {
                            var tagName = el[0].tagName.toLowerCase();
                            if (formatting.indexOf(tagName) > 0 && nodeType !== Node.TEXT_NODE) {
                                changed = checkFormatting(el);
                            } else {
                                var newEl = el.closest(formatting.join(','));
                                if (newEl.length) {
                                    changed = checkFormatting(newEl);
                                }
                            }
                        }
                        if (!changed) {
                            obj.dropdown.find('a.redactor-formatting-p').addClass('selected');
                        }
                    }
                    widget.richDD.obj = obj.dropdown;
                    widget.richDD.offset = obj.dropdown.position();
                    widget.updateRichDdPosition();
                    obj.dropdown.data("fotobook-containerEditor-toolbar", widget.toolbar);
                    if (obj.dropdown.hasClass('redactor-dropdown-box-fontfamily') || obj.dropdown.hasClass('redactor-dropdown-box-fontsize')) {
                        obj.dropdown.off(".redactor-dropdown").on("click.redactor-dropdown", function (e) {
                            var target = $(e.target);
                            if (target.closest(".jspVerticalBar,.jspHorisontalBar").length) {
                                return false;
                            }
                        });
                        obj.dropdown.attr('data-jsp-init', '{"doNotShowHScroll": true}');
                        //инициализация скролла
                        setTimeout(() => obj.dropdown.initJsp(), 0);
                    }
                },
            });
        },
        _putData: function (key, value) {
            this._getTextContent().attr('data-' + key, value);
        },
        _getSaveContent: function(){
            var new_content,
                clone;

            if (this.edit_mode == this.TYPE_RICHTEXT) {
                if (Fotobook.book.forceFontSizeToEm.call(this.element.find(".redactor-editor").children())){
                    this.redactorArea.redactor("code.startSync");
                }

                new_content = this.redactorArea.redactor("code.get");
            } else {
                Fotobook.book.forceFontSizeToEm.call(this._getTextContent());
                clone = this._getTextContent().clone();
                new_content = clone.removeAttr("contenteditable")[0].outerHTML;
                if (clone.text().trim() == '') {
                    new_content = new_content.replace('<br>', '');
                }
                clone.remove();
            }
            if (this.edit_mode == this.TYPE_SPINE) {
                new_content = $(new_content).text($.trim($(new_content).text())).outerhtml();
            }
            return (new_content || "");
        },

        // todo: костыль, нужно пересмотреть редактирование корешка
        _copySpine: function () {
            if (this.edit_mode == this.TYPE_SPINE) {
                var $caption = this.caption.get(0);
                if ($caption) {
                    this.element.find(".container-box-shadow").html($caption.outerHTML).find(".text-content").removeAttr("contenteditable");
                    Fotobook.book.recalcContainer.call(this.element);
                }
            }
        },
        action_bold: function(){
            var textcontent = this._getTextContent(),
                weight = textcontent.attr("data-font-weight") == "bold" ? "normal" : "bold";
            textcontent.css('font-weight', weight);
            this._putData("font-weight", weight);
        },
        action_italic: function(){
            var textcontent = this._getTextContent(),
                style = textcontent.attr("data-font-style") == "italic" ? "normal" : "italic";
            textcontent.css('font-style', style);
            this._putData("font-style", style);
        },
        action_alignjustify: function(){
            this._getTextContent().css('text-align', 'justify');
            this._putData('align', 'justify');
        },
        action_alignleft: function(){
            this._getTextContent().css('text-align', 'left');
            this._putData('align', 'left');
        },
        action_aligncenter: function(){
            this._getTextContent().css('text-align', 'center');
            this._putData('align', 'center');
        },
        action_alignright: function(){
            this._getTextContent().css('text-align', 'right');
            this._putData('align', 'right');
        },
        changeVAlign(vAlign) {
            const lastVAlign = Number(this.caption.attr('data-vertical_align'));
            this.caption.attr('data-vertical_align', vAlign);
            Fotobook.containers.changeContainerAttrs({
                [this.containerId]: {
                    caption: {
                        vertical_align_current: vAlign,
                    },
                },
            }).catch(() => {
                this.caption.attr('data-vertical_align', lastVAlign);
            });
        },
        action_valignstart() {
            this.changeVAlign(Fotobook.CaptionAlign.START);
        },
        action_valigncenter() {
            this.changeVAlign(Fotobook.CaptionAlign.CENTER);
        },
        action_valignend() {
            this.changeVAlign(Fotobook.CaptionAlign.END);
        },
        action_clear: function(){
            if (this.edit_mode == this.TYPE_RICHTEXT) {
                this.redactorArea.redactor('code.set', '');
                this.redactorArea.redactor('focus.setEnd');
            }
            this._getTextContent().empty();
            this._checkButtons();
        },
        _getPageZindexes() {
            let max = Fotobook.book.getContainerZindex(this.group[0]);
            let min = max;
            const this_id = parseInt(this.group.attr('data-id'), 10);
            const data = {
                idx: -1,
                containers: [{
                    id: this_id,
                    idx: 1,
                    zindex: Fotobook.book.getContainerZindex(this.group[0]),
                }],
            };
            this.element.closest(Fotobook.book.book).find(".book-page").find(".page-container.top-level").each(function (idx) {
                const $this = $(this);
                const zindex = Fotobook.book.getContainerZindex(this);
                const id = parseInt($this.attr('data-id'), 10);

                if ($this.parents(".group-container").length || data.containers[0].id == id) {
                    return;
                }
                max = Math.max(max, zindex);
                min = Math.min(min, zindex);
                data.containers.push({
                    id,
                    idx: data.containers[0].idx + idx + 1,
                    zindex,
                });
            });
            data.maxZindex = max;
            data.minZindex = min;
            data.containers.sort(function (a, b) {
                return a.zindex - b.zindex;
            });
            for (var i = 0, l = data.containers.length; i < l; i++) {
                if (this_id == data.containers[i].id) {
                    data.idx = i;
                    break;
                }
            }
            return data;
        },
        checkEnableClearButton: function(){
            var text, enable = false;
            if (!this._isTextEditor()){
                return false;
            }

            if ((this.edit_mode == this.TYPE_RICHTEXT)) {
                if (this.redactorArea && this.redactorArea.data("redactor")) {
                    text = $($.parseHTML(["<div>", this.redactorArea.redactor("code.get"), "</div>"].join("")));
                    enable = $.trim(text.text()).length;
                    text.remove();
                }
            } else {
                enable = $.trim(this._getTextContent().text()).length;
            }
            return !!enable;
        },
        /**
         * Установить состояние кнопок управления слоем
         * @private
         */
        _checkZindexButtons: function(){
            var zbuttons = this._getButtons(["toback", "backward", "forward", "totop"]),
                data,
                isPhotoOverlay = this.element.hasClass(Fotobook.CONT_SUBTYPE_FOTOWINDOW_CLASS); // фотонакладка

            if (!zbuttons.length) {
                return;
            }

            // отключить для фотоконтейнеров FOT-463
            if(isPhotoOverlay) {
                this.disableButtons(zbuttons);
                return;
            }

            const zindex = Fotobook.book.getContainerZindex(this.group[0]);
            data = this._getPageZindexes();

            if (data.containers.length > 0) {
                this.enableButtons(zbuttons);
                if (data.idx == 0) {
                    this.disableButtons(["toback", "backward"]);
                }
                if (data.idx >= data.containers.length - 1) {
                    this.disableButtons(["forward", "totop"]);
                }
            } else {
                this.disableButtons(zbuttons);
            }
        },
        // Делаем через setTimeout, чтобы успел обновиться класс плохого качества
        _checkFitQualityButton: function(){
            var widget = this;
            setTimeout(function(){
                widget.toggleButtons("fitquality", function(){
                    return widget.element.hasClass("low-quality-container") &&
                            !widget.element.hasClass("locked") &&
                            !widget.element.hasClass("empty");
                });
            }, 0);
        },
        _checkShapeByFotoButton: function(){
            var toolbar = this.toolbar;
            setTimeout(function(){
                toolbar.find(".tb-button.tb-setshapebyfoto").removeClass("active");
            }, 0);
        },
        _checkButtons_BG: function(){
            var widget = this;
            if (!this._isBg()){
                return;
            }

            if (!Fotobook.book.cover.foto_clipart && this.element.closest(".book-page").hasClass("cover")){
                setTimeout(function(){
                    widget.destroy();
                });
            }
            this.toggleButtons(["opacity", "deletecont"], this.element.find(".bg-clipart").length);
            this.toggleButtons(["delfoto", "croppingzoom"], this.element.find(".bg-clipart-foto").length);
        },
        _checkButtons_FrameOptions: function(){
            var frame = this.element.find(".frame-vector");
            this.toggleButtons("framerx", frame.length && frame.hasClass('apply-rx'));
            this.toggleButtons("contrx", !frame.length);
            this.toggleButtons("strokewidth", frame.length);
        },
        /**
         * Установить состояние кнопок тени
         * @private
         */
        _checkButtons_Shadow: function(){
            var shadow = this.element.find('.filter-drop-shadow'),
                shadowText = this.element.find('.text-content').css('text-shadow') !== "none",
                shadowButtons = ["removeshadow", "shadowopacity", "shadowblur", "shadowposition"],
                isPhotoOverlay = this.element.hasClass(Fotobook.CONT_SUBTYPE_FOTOWINDOW_CLASS), // фотонакладка;
                isTextContainer = Number(this.element.attr('data-container-type')) === Fotobook.ContainerType.CAPTION;
            // отключить для фотоконтейнеров FOT-463
            if(isPhotoOverlay) {
                shadowButtons.push('addshadow');
                this.disableButtons(shadowButtons);
                return;
            }

            this.toggleButtons("addshadow", isTextContainer ? !shadowText : !shadow.length);
            this.toggleButtons(shadowButtons, isTextContainer ? shadowText : shadow.length);
        },
        _updateButtonsShadow: function(){
            const widget = this,
                shadow = widget._getOpacityParams();

            if (Object.keys(shadow).length) {
                widget._updateShadowSlider(widget.toolbar.find('.tb-shadowopacity').find('.input-range-slider'), shadow.opacity);
                widget._updateShadowSlider(widget.toolbar.find('.tb-shadowblur').find('.input-range-slider'), shadow.blur);
                widget._updateShadowSlider(widget.toolbar.find('.tb-shadowposition').find('.shadowposition-x'), shadow.dx);
                widget._updateShadowSlider(widget.toolbar.find('.tb-shadowposition').find('.shadowposition-y'), shadow.dy);
            }
        },

        _getOpacityParams: function() {
            const widget = this,
                isTextContainer = Number(widget.element.attr('data-container-type')) === Fotobook.ContainerType.CAPTION,
                $shadowElement = widget.element.find(isTextContainer ? '.text-content' : '.filter-drop-shadow');
            let shadow = {};
            if(isTextContainer) {
                shadow.opacity = parseFloat(new WebColor(widget.element.attr('data-shadow-color')).getAlpha()) * 100;
                shadow.blur = parseFloat(widget.element.attr('data-shadow-blur')) * 1000;
                shadow.dx = parseFloat(widget.element.attr('data-shadow-dx')) * 1000;
                shadow.dy = parseFloat(widget.element.attr('data-shadow-dy')) * 1000;
            } else {
                shadow.opacity = parseFloat($shadowElement.find('.apply-flood-opacity').attr('flood-opacity')) * 100;
                shadow.blur = parseFloat($shadowElement.find('.apply-shadow-blur').attr('data-blur')) * 1000;
                shadow.dx = parseFloat($shadowElement.find('.apply-shadow-blur').attr('data-blur')) * 1000;
                shadow.dy = parseFloat($shadowElement.find('.apply-shadow-blur').attr('data-blur')) * 1000;
            }
            return shadow;
        },

        _updateShadowSlider: function (slider, value) {
                slider.slider('value', value);
                slider.attr('data-value', value);
                slider.find('.ui-slider-handle').attr('title', value);
        },

        /** установить значения элементов выпадающего меню текстового контейнера */
        _checkButtons_TEXT: function(){
            if (!this._isTextEditor()) {
                return;
            }
            const $textContent = this._getTextContent();
            const $caption = this.caption;
            const dataAlign = $textContent.attr('data-align') || $caption.attr('data-align');
            let dataFontStyle = $textContent.attr('data-font-style') || $caption.attr('data-font-style');
            let dataFontWeight = $textContent.attr('data-font-weight') || $caption.attr('data-font-weight');
            const dataFontColor = $textContent.attr('data-fcolor') || $caption.attr('data-fcolor');
            const dataBgColor = $textContent.attr('data-bgcolor') || $caption.attr('data-bgcolor');

            if (dataFontStyle !== "italic") {
                dataFontStyle = "normal";
            }
            this._putData("font-style", dataFontStyle);
            this.toggleActive("italic", dataFontStyle == "italic");

            if (dataFontWeight != "bold"){
                dataFontWeight = "normal";
            }
            this._putData("font-weight", dataFontWeight);
            this.toggleActive("bold", dataFontWeight == "bold");


            this.toggleButtons("clear", this.checkEnableClearButton);

            if (this._isSpine()) {
                var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(dataFontColor),
                    rgb = result ? {
                        "r": parseInt(result[1], 16),
                        "g": parseInt(result[2], 16),
                        "b": parseInt(result[3], 16)
                    } : null;
                this.checkColorBrightness(rgb);
            }
            this._putData("fcolor", dataFontColor);
            this._putData("bgcolor", dataBgColor);

            $textContent.css({
                "text-align": dataAlign || this.caption.attr("data-align"),
                "font-style": dataFontStyle,
                "font-weight": dataFontWeight
            });
            this.deactivateButtons("align");
            this.activateButtons("align" + (dataAlign || this.caption.attr("data-align")));
        },

        /** инициализировать контролы календаря */
        _checkButtons_Calendar: function(){
            if (this.edit_mode !== this.TYPE_CALENDAR) {
                return;
            }

            this.toggleButtons("dayNamesPosition", function($button){
                var value = parseInt(this.element.attr('data-day_names_position'), 10);
                $button
                    .toggleClass('days-show', !value)
                    .toggleClass('days-hide', !!value);
                return true;
            }, "");
        },

        // todo Это всё нужно разделить, возможно - кнопки поделать виджетами
        /** установить значения элементов выпадающего меню */
        _checkButtons_call: function(){
            this._checkButtons_BG();
            this._checkButtons_TEXT();

            this._checkFitQualityButton();
            this._checkShapeByFotoButton();
            this._checkZindexButtons();
            this._checkButtons_FrameOptions();
            this._checkButtons_Shadow();
            this._checkButtons_Calendar();

            this.toggleButtons("delframe", function(){
                return this.element.find(".frame").length;
            });
            this.toggleButtons("delmask", function(){
                return this.element.find(".mask").length;
            });
            this.toggleButtons("contrx", function(){
                const mask = this.element.find(".mask");
                return !mask.length || mask.attr('data-figure') === Fotobook.book.FIGURE_TYPE.RECT;
            });
            this.toggleButtons(["rotateleft", "rotateright"], function(){
                return !(this.element.hasClass("empty") || this.element.hasClass("no-original"));
            });
            if (!this._isBg()) {
                this.toggleButtons("deletecont", !this.element.hasClass("locked"));
                this.toggleButtons(["delfoto", "croppingzoom"], !this.element.hasClass("empty"));
            }
            this.toggleButtons("editgroup", function(){
                return this.element.parents(".group-container").length;
            });
            this.toggleButtons("setshapebyfoto", this.element.hasClass("top-level") && !this.element.hasClass("empty") && !this.element.hasClass("locked") && !this.element.hasClass(Fotobook.CONT_SUBTYPE_FOTOWINDOW_CLASS));
            this.toggleButtons(["group", "selectedtoleft", "selectedtoright", "selectedtotop", "selectedtobottom"], function(){
                // для группы элементов применять
                return $(".page-container.selected").length > 1
            });
            this._checkProportionalResize();
            this._trigger("checkButtons");
        },

        _checkProportionalResize: function(){
            var ar = !!(this.edit_mode == this.TYPE_ARTEFACT || this.edit_mode == this.TYPE_GROUP/* || this.edit_mode == this.TYPE_FOTO && this.element.find(".gfx-frame").length*/), // не знаю, будем ли это использовать
                resizable = this.element.data("ui-resizable");
            if (!resizable){
                return;
            }
            if (resizable.option("aspectRatio") != ar){
                resizable.option("aspectRatio", ar);
            }
            this.group.toggleClass("fotobook-resizable-proportional", ar);
        },
        _checkButtons_queued: false,
        _checkButtons: function(){
            var widget = this;
            if (!widget._checkButtons_queued) {
                widget._checkButtons_queued = true;
                setTimeout(function(){
                    widget._checkButtons_queued = false;
                    widget._checkButtons_call.call(widget);
                }, 0);
            }
        },
        checkButtons: function(){
            this._checkButtons();
        },
        processButton: function (event) {
            var button = $(this),
                widget = event.data.widget,
                buttonRole = button.attr("data-role"),
                buttonFun = "action_" + buttonRole,
                element;

            if (button.hasClass("disabled") || button.hasClass("ui-state-disabled")) {
                return false;
            }
            if (typeof widget[buttonFun] == "function") {
                if (button.hasClass("tb-popup")) {
                    event.type = button.hasClass("active") ? "popupclose" : "popupopen";
                    //widget.element.data('qtip').disable(true);
                    widget[buttonFun](event);
                } else {
                    widget[buttonFun](this);
                }

                if (button.closest('[data-role="dropdown"]').length && (button.closest('.tb-dropdown-options').is(":visible"))) {
                    button.closest('[data-role="dropdown"]').find(".active").removeClass("active");
                }

                const radio = button.attr('data-radio');
                if (radio) {
                    widget.toolbar.find(".tb-button").filter('[data-radio="' + radio + '"]').removeClass("active");
                    button.addClass("active");

                } else {
                    // затычка, чтобы клик по самому меню не закрывал его. Пересмотреть в будущем
                    if (!$(event.target).hasClass("tb-dropdown-options")){
                        button.toggleClass("active");
                    }
                }
                if (buttonRole != "close"){
                    widget._copySpine();
                }
            }

            if (!button.hasClass("active") && (!button.closest('.tb-dropdown-options').length || !button.closest('.tb-popup-window').length)) {
                button.closest('.tb-buttons').find('.active[data-role="dropdown"]').removeClass("active");
            }

            if (widget._isTextEditor()) {
                element = (widget.edit_mode == widget.TYPE_SPINE) ? $("#spineEditor") : widget.element;
                if ($(event.target).data("role") != "deletecont") {
                    element.find(".text-content[contenteditable]").focus();
                }
            }
            widget.updateToolbarPosition_call();
        },
        _getButtons: function (buttons) {
            if (typeof (buttons) === "string") {
                buttons = buttons.split(",");
            }
            if (buttons instanceof Array) {
                buttons = this.toolbar.find(".tb-" + buttons.join(",.tb-"));
            }
            return buttons;
        },
        /**
         * Изменить состояние кнопок согласно заданому классу
         *
         * @param buttons
         * @param condition
         * @param classes
         */
        toggleButtons: function (buttons, condition, classes) {
            var self = this;
            classes = classes || "disabled qtip-disabled";
            this._getButtons(buttons).each(function(){
                var $button = $(this),
                    buttonCondition = condition;
                if (typeof buttonCondition == "function") {
                    buttonCondition = buttonCondition.call(self, $button);
                }
                $button.toggleClass(classes, !buttonCondition);
            });
        },
        disableButtons: function (buttons) {
            this.toggleButtons(buttons, false);
        },
        enableButtons: function (buttons) {
            this.toggleButtons(buttons, true);
        },
        toggleActive: function (buttons, condition) {
            this.toggleButtons(buttons, !condition, 'active');
        },
        deactivateButtons: function (buttons) {
            this.toggleActive(buttons, false);
        },
        activateButtons: function (buttons) {
            this.toggleActive(buttons, true);
        },
        getTextContainer: function(){
            if (this.edit_mode == this.TYPE_TEXT){
                return this._getTextContent();
            } else if (this.edit_mode == this.TYPE_RICHTEXT){
                return this.element.find(".redactor-editor");
            } else if (this.edit_mode == this.TYPE_SPINE){
                return this.toolbar.closest(".spine-editor").find(".text-content");
            }
        },
        checkTextContainerHeight: function () {
            if (this.element.closest('.group-container').length || !this._isTextEditor() || this.edit_mode === this.TYPE_SPINE) {
                return false;
            }
            const $target = this.getTextContainer();
            const $container = this.element;
            const diff = $target.height() - $container.height();

            if (diff > 0) {
                const matrix = $container.getRotationMatrix();
                const d = $.extend({}, $.ui.resizable.prototype, {
                    matrix,
                    matrix_reverse: $.ui.resizable.prototype._matrix_reverse_rotate(matrix),
                    originalSize: {
                        width: $container.width(),
                        height: $container.height(),
                    },
                    originalPosition: {
                        top: Number($container.css('top')),
                        left: Number($container.css('left')),
                    },
                    _aspectRatio: false,
                });
                const event = {};
                const r = $.ui.resizable.prototype._change.s.call(d, event, 0, diff);
                const affectedCoords = ['top', 'left', 'width', 'height'];
                Fotobook.book.backupInitialCoordinates($container, affectedCoords);
                if ($target.height() > $(window).height()) {
                    $container.css('overflow', 'hidden');
                    const $book = $container.closest('.pages-wrapper');
                    const bookRect = $book[0].getBoundingClientRect();
                    const containerRect = $container[0].getBoundingClientRect();
                    $container.height(bookRect.bottom - containerRect.top);
                    $container.css('overflow', 'visible');
                } else {
                    $container.css(r);
                }
                setTimeout(() => Fotobook.book.saveContainerPosition($container, affectedCoords), 0);
                this.updateToolbarPosition();
                return true;
            }
            return false;
        },
        update_control_opacity: function (opacity) {
            var $slider = this.toolbar.find(".tb-opacity").find(".ui-slider");
            opacity = Math.round(opacity * 100);
            setTimeout(function(){
                var old = $slider.slider("value");
                if (old != opacity) {
                    $slider.slider("value", opacity);
                }
            }, 0);
        },
        update_control_shadowopacity: function (opacity) {
            var $slider = this.toolbar.find(".tb-shadowopacity").find(".ui-slider");
            opacity = Math.round(opacity * 100);
            setTimeout(function(){
                var old = $slider.slider("value");
                if (old != opacity) {
                    $slider.slider("value", opacity);
                    $slider.find(".ui-slider-handle").attr("title", opacity); //0050573: меняем значение для хинта
                }
            }, 0);
        },
        action_opacity(event, ui) {
            let el = this.element;
            const opacity = ui ? ui.value / 100 : undefined;

            if (this._isBg() && el.closest('.bg-spread').length) {
                el = el.closest('.pages-wrapper').find('.bg-content');
            }
            const selector = Fotobook.book.getElementSelector(el);

            if (event.type === 'slidestart') {
                $(selector).each(function () {
                    this.setAttribute('data-original-opacity', Fotobook.book.getOpacity(this));
                });
            } else if (event.type === 'slidestop') {
                const params = {};
                el.each(function(){
                    var id = Number(this.getAttribute('data-id'));
                    if (id) {
                        params[id] = {
                            opacity: ui.value,
                        };
                    }
                });
                Fotobook.containers.changeContainerAttrs(
                    params
                ).catch(() => {
                    const value = 100 * el.attr('data-original-opacity');
                    $(ui.handle).closest('.ui-slider').slider('value', value);
                    $(selector).each(function () {
                        Fotobook.book.setOpacity(this, this.getAttribute('data-original-opacity'));
                    });
                }).finally(() => {
                    $(selector).removeAttr('data-original-opacity');
                });
            } else if (event.type === 'slide') {
                Fotobook.book.setOpacity($(selector), opacity);
            }
        },
        action_swapphotos: function (event, ui) {
            const getContainerData = ($cont) => {
                const contId = Number($cont.attr('data-id'));
                const image = $cont.find('.foto-image');
                const imagePath = image.attr('xlink:href');
                if (!image || !imagePath) {
                    return {
                        container_id: contId,
                    };
                }
                return {
                    container_id: contId,
                    foto_angle: Number($cont[0].style.getPropertyValue('--container-foto_angle')) || 0,
                    foto_id: image.attr('data-id'),
                    href: imagePath,
                    foto_width: Number(image.attr('data-width')),
                    foto_height: Number(image.attr('data-height')),
                    crop_cx: Number(image.attr('data-crop_cx')),
                    crop_cy: Number(image.attr('data-crop_cy')),
                    crop_width: Number(image.attr('data-crop_width')),
                    crop_height: Number(image.attr('data-crop_height')),
                    original_exists: image.attr('data-original_exists'),
                };
            };

            const firstElement = this.element;
            const pages = firstElement.closest(".pages-wrapper").find(".book-page");
            const selector = Fotobook.book.getElementSelector(firstElement);
            const containers = pages.find('.foto-container:not(' + selector + ')');
            containers.addClass('ready-for-swap');
            containers.on('click.swapPhotos', function (event) {
                containers.off('click.swapPhotos');
                containers.removeClass('ready-for-swap');

                const secondElement = $(this);
                const firstElementData = getContainerData(firstElement);
                const secondElementData = getContainerData(secondElement);
                const firstElementContainerId = firstElementData.container_id;
                const secondElementContainerId = secondElementData.container_id;

                firstElementData.container_id = secondElementData.container_id;
                secondElementData.container_id = firstElementContainerId;

                Fotobook.book.setContainerImage(firstElementData);
                Fotobook.book.setContainerImage(secondElementData);
                Fotobook.import.uploadComplete();
                Fotobook.containers.changeContainerAttrs({
                    [firstElementContainerId] : {
                        foto_id: secondElementData.foto_id || 0
                    },
                    [secondElementContainerId] : {
                        foto_id: firstElementData.foto_id || 0
                    },
                });
            });
        },
        action_calendarBorderWidth: function (event, ui) {
            var dataStyleClass = "calendarBorderWidthStyleClass";

            if (event.type == "slidestop") {
                if (ui.value === parseInt(this.element.attr("data-border_width"), 10)){
                    Fotobook.containers.calendar.style.removeOverride(dataStyleClass);
                }

                var containerId = this.containerId,
                    containers = {};

                containers[containerId] = {
                    "calendar" : {
                        "border_width" : ui.value,
                    },
                };
                Fotobook.containers.changeContainerAttrs(containers).catch(()=>null).finally(() => {
                    Fotobook.containers.calendar.style.removeOverride(dataStyleClass);
                });
            } else if (event.type === "slide") {
                Fotobook.containers.calendar.style.addOverride(this.element, "borderWidth", {
                    "border_width" : ui.value,
                }, dataStyleClass);
            }
        },

        _croppingzoom_set_slider_value(slider, cropWidth, cropHeight) {
            const minValue = slider.options.min;
            const maxValue = slider.options.max;
            const value = Math.round(Math.min(maxValue, Math.max(minValue, Math.max(cropWidth, cropHeight))));

            const percent = Math.min(300, Math.round(100 * 100 / value));
            slider.handle.attr('title', `${percent}%`);
            const newValue = maxValue - (value - minValue);
            slider.value(newValue);
        },
        croppingzoomFoto(event, ui) {
            if (event.type === 'popupclose') {
                return;
            }

            const widget = this;
            const $cont = this.element;
            const slider = (ui ? $(ui.handle).closest('.ui-slider') : $(event.target).find('.ui-slider')).data('ui-slider');
            const minValue = slider.options.min;
            const maxValue = slider.options.max;
            const cropping = $cont.find('.cropping')[0];
            const fs = Fotobook.book.getCurrentFontSize.call($cont);
            const bleed = fs * Fotobook.book.getClearSize(parseFloat($cont.attr('data-bleed')));
            const contW = cropping.width.baseVal.value + 2 * bleed;
            const contH = cropping.height.baseVal.value + 2 * bleed;
            const $img = $cont.find('.foto-image');
            // Ранее использовался 0-ой элемент, но его значения в Хроме !
            // width.baseVal.value и img.height.baseVal.value стали нулевыми.
            // В Лисе все ОК. Выяснить причину пока не удалось.
            // @author: Sergey Potyomkin
            const img = $img[1];
            const imgCurWidth = img.width.baseVal.value;
            const imgCurHeight = img.height.baseVal.value;
            const cropCx = Number($img.attr('data-crop_cx') ?? 50);
            const cropCy = Number($img.attr('data-crop_cy') ?? 50);
            const containerFotoAngle = Number($cont[0].style.getPropertyValue('--container-foto_angle')) || 0;
            const fotoOwnAngle = Number($img[0].style.getPropertyValue('--foto-angle')) || 0;
            const angle = containerFotoAngle + fotoOwnAngle;
            const rotatedContSize = Fotobook.transforms.getRotatedBoundingBox(-angle, contW, contH);
            const cropWidth = rotatedContSize.width / imgCurWidth * 100;
            const cropHeight = rotatedContSize.height / imgCurHeight * 100;

            if (event.type === 'popupopen') {
                widget._croppingzoom_set_slider_value(slider, cropWidth, cropHeight);
            } else if (event.type === 'slidestart') {
                Fotobook.book.backupInitialCoordinates($cont, ['cx', 'cy', 'crop_width', 'crop_height']);
                $('html').add($cont).addClass('crop-dragging');
            } else if (event.type === 'slidestop') {
                const params = {};
                const moveStarted = ($cont.data('fotobook-initial') || {}).time;

                params[$cont.attr('data-id')] = {
                    crop_cx: cropCx,
                    crop_cy: cropCy,
                    crop_width: cropWidth,
                    crop_height: cropHeight,
                    move_started: moveStarted,
                };

                Fotobook.containers.changeContainerAttrs(params).catch(() => {
                    widget.action_croppingzoom({
                        type: 'popupopen',
                    }, ui);
                });
                $('html').add($cont).removeClass('crop-dragging');
            } else if (event.type === 'slide') {
                const value = maxValue - Fotobook.helpers.urange(minValue, ui.value, maxValue) + minValue;
                $(ui.handle).attr('title', Math.min(Math.round(100 * 100 / value), 300) + '%');

                let newCropWidth;
                let newCropHeight;
                if (cropWidth > cropHeight) {
                    newCropWidth = value;
                    newCropHeight = Math.min(value * imgCurWidth / imgCurHeight * rotatedContSize.height / rotatedContSize.width, 100);
                } else {
                    newCropHeight = value;
                    newCropWidth = Math.min(value * imgCurHeight / imgCurWidth * rotatedContSize.width / rotatedContSize.height, 100);
                }

                const newCropCx = Fotobook.helpers.urange(newCropWidth / 2, cropCx, 100 - newCropWidth / 2);
                const newCropCy = Fotobook.helpers.urange(newCropHeight / 2, cropCy, 100 - newCropHeight / 2);
                $img.attr({
                    'data-crop_cx': newCropCx,
                    'data-crop_cy': newCropCy,
                    'data-crop_width': newCropWidth,
                    'data-crop_height': newCropHeight,
                });
                Fotobook.book.recalcContainer_call.call($cont);
            }
        },
        croppingzoomBg(event, ui) {
            if (event.type === 'popupclose') {
                return;
            }

            const slider = (ui ? $(ui.handle).closest('.ui-slider') : $(event.target).find('.ui-slider')).data('ui-slider');
            if (!slider) {
                return;
            }
            const spread = this.element.closest('.bg-spread').length > 0;
            // const right = this.element.closest(".book-page.right").length > 0, // not used
            const minValue = slider.options.min;
            const maxValue = slider.options.max;
            const $spine = $('.page-container.spine:visible');
            const spineWidth = $spine[0]?.getBoundingClientRect()?.width ?? 0;
            const $cont = this.element;
            const cropping = $cont.find('.bounding-box')[0];
            const $spreadConts = Fotobook.book.getSingleOrSpreadBg($cont).find('.bg-content');
            const $spreadImages = $spreadConts.find('.bg-clipart-foto');
            const $img = $cont.find('.bg-clipart-foto');
            throw new Error('Not implementd in UI!!!');
            const fotoAngle = Number($img[0].style.getPropertyValue('--foto-angle'));
            const fotoWidth = Number($img.attr('data-width'));
            const fotoHeight = Number($img.attr('data-height'));
            const croppingBox = cropping.getBoundingClientRect();
            const rotatedContSize = Fotobook.transforms.getRotatedBoundingBox(-fotoAngle, cropping.width.animVal.value, cropping.height.animVal.value);
            const contRotatedW = rotatedContSize.width;
            const contRotatedH = rotatedContSize.height;
            const cropWidth = 100 * contRotatedW / $img[0].width.animVal.value;
            const cropHeight = 100 * contRotatedH / $img[0].height.animVal.value;
            const cropCx = Number($img.attr('data-crop_cx'));
            const cropCy = Number($img.attr('data-crop_cy'));

            if (event.type === 'popupopen') {
                this._croppingzoom_set_slider_value(slider, cropWidth, cropHeight);
            } else if (event.type === 'slidestart') {
                $('html').add($spreadConts).addClass('crop-dragging');
            } else if (event.type === 'slidestop') {
                const $img2 = Fotobook.book.getAdjacentPage($img).find('.bg-clipart-foto-half');
                const data = {
                    crop_cx: cropCx,
                    crop_cy: cropCy,
                    crop_width: cropWidth,
                    crop_height: cropHeight,
                };

                const params = {
                    [$cont.attr('data-id')]: data,
                };
                if ($img2.length && $img.hasClass('bg-clipart-foto-half') && ($img.attr('data-id') === $img2.attr('data-id'))) {
                    params[$img2.closest('.bg-content').attr('data-id')] = data;
                }
                Fotobook.containers.changeContainerAttrs(params);

                $('html').add($spreadConts).removeClass('crop-dragging');
            } else if (event.type === 'slide') {
                const value = maxValue - Math.max(minValue, Math.min(ui.value, maxValue)) + minValue;
                const titlePercent = Math.min(300, Math.round(100 * 100 / value));
                $(ui.handle).attr('title', `${titlePercent}%`);

                let newCropWidth;
                let newCropHeight;
                if (cropWidth > cropHeight) {
                    newCropWidth = value;
                    newCropHeight = Math.min(value * fotoWidth / fotoHeight * contRotatedH / contRotatedW, 100);
                } else {
                    newCropHeight = value;
                    newCropWidth = Math.min(value * fotoHeight / fotoWidth * contRotatedW / contRotatedH, 100);
                }

                const newCropCx = Fotobook.helpers.urange(newCropWidth / 2, cropCx, 100 - newCropWidth / 2);
                const newCropCy = Fotobook.helpers.urange(newCropHeight / 2, cropCy, 100 - newCropHeight / 2);
                $spreadImages.each((index, img) => {
                    const $currentImg = $(img);
                    const $currentCont = $currentImg.closest('.bg-content');
                    const $visible = $currentCont.find('.bg-cropping-visible');
                    const $currentPage = $currentImg.closest('.book-page');
                    const odd = $currentPage.hasClass('page_odd');
                    const px2em = Fotobook.book.getPxToEmK.call(img);

                    const newCropping = Fotobook.book.getFotoBgCroppingAttrs({
                        angle: fotoAngle,
                        foto_width: Number($currentImg.attr('data-width')),
                        foto_height: Number($currentImg.attr('data-height')),
                        crop_width: newCropWidth,
                        crop_height: newCropHeight,
                        cont_width: croppingBox.width,
                        cont_height: croppingBox.height,
                        visible_w: $currentCont.width(),
                        visible_h: $currentCont.height(),
                        crop_cx: newCropCx,
                        crop_cy: newCropCy,
                        center_x: $visible.width() / 2 - (spread && odd ? $currentCont.width() + spineWidth : 0),
                        center_y: $visible.height() / 2,
                    });
                    $currentImg.attr({
                        width: Fotobook.book.getSizeInEm(newCropping.image_width * px2em),
                        height: Fotobook.book.getSizeInEm(newCropping.image_height * px2em),
                        'data-x1': newCropping.x1,
                        'data-x2': newCropping.x2,
                        'data-y1': newCropping.y1,
                        'data-y2': newCropping.y2,
                        'data-crop_cx': newCropCx,
                        'data-crop_cy': newCropCy,
                        'data-crop_width': newCropWidth,
                        'data-crop_height': newCropHeight,
                    });
                    img.style.transform = Fotobook.book.getFotoBackgroundTransform(
                        fotoAngle,
                        Fotobook.book.getSizeInEm(-newCropping.x * px2em),
                        Fotobook.book.getSizeInEm(-newCropping.y * px2em),
                    );
                });
            }
        },
        action_croppingzoom(event, ui) {
            if (this._isBg()) {
                return this.croppingzoomBg(event, ui);
            }
            return this.croppingzoomFoto(event, ui);
        },
        // Saving z-indexes
        _setPageZindexes(data) {
            const params = {};
            for (let i = 0, l = data.length; i < l; i++) {
                params[data[i].id] = {
                    z_index: i + 1,
                };
            }
            Fotobook.containers.changeContainerAttrs(params);
        },
        // z-index to top level
        action_totop() {
            var data = this._getPageZindexes();

            if (data.idx < 0 || data.idx >= data.containers.length - 1){
                return;
            }
            const element = data.containers.splice(data.idx, 1);
            data.containers.push(element[0]);
            this._setPageZindexes(data.containers);
        },
        // z-index tobotoom level
        action_toback: function(){
            var data = this._getPageZindexes(),
                element;

            if (data.idx < 1){
                return;
            }
            element = data.containers.splice(data.idx, 1);
            data.containers.unshift(element[0]);
            this._setPageZindexes(data.containers);
        },
        // z-index -1 level
        action_backward: function(){
            var data = this._getPageZindexes(),
                element;

            if (data.idx < 1){
                return;
            }
            element = data.containers.splice(data.idx, 1);
            data.containers.splice(data.idx - 1, 0, element[0]);
            this._setPageZindexes(data.containers);
        },
        // z-index +1 level
        action_forward: function(){
            var data = this._getPageZindexes(),
                element;

            if (data.idx >= data.containers.length - 1){
                return;
            }
            element = data.containers.splice(data.idx, 1);
            data.containers.splice(data.idx + 1, 0, element[0]);
            this._setPageZindexes(data.containers);
        },
        action_ungroup: function(){
            Fotobook.containers.ungroup(this.containerId);
        },
        action_editgroup: function(){
            if (this.element != this.group) {
                this.group.trigger("click");
            }
        },
        action_group: function(){
            var rect = this._getSelectionRect(),
                page = Fotobook.book.getPageByPixel(rect.left + rect.width / 2),
                params = {
                    "page_id": parseInt(page.attr("data-id"), 10),
                    "containers": [],
                };
            $(".page-container.selected").each(function(){
                params.containers.push(parseInt(this.getAttribute("data-id"), 10));
            });
            if (params.containers.length < 2){
                return;
            }
            Fotobook.containers.group(params).then((response) => {
                const $book = $(Fotobook.book.book);
                for (var id in response.data.containers) {
                    let $cont = $book.find(Fotobook.book.getContainerSelector(id));
                    if ($cont.length) {
                        if (!$cont.data("fotobook-containerEditor")) {
                            $cont.containerEditor();
                            return;
                        }
                    }
                }
            }).catch(() => null);
        },
        _align_selection: function (side) {
            var rect = this._getSelectionRect(),
                side_attr = {
                    "top": "top",
                    "bottom": "top",
                    "left": "left",
                    "right": "left",
                },
                prop = side_attr[side],
                containers = {};

            $(".page-container.selected").each(function(){
                var $this = $(this),
                    id = parseInt(this.getAttribute("data-id"), 10),
                    thisrect = this.getBoundingClientRect();
                Fotobook.book.backupInitialCoordinates($this, [prop]);
                $this.css(prop, parseFloat($this.css(prop)) + rect[side] - thisrect[side] + "px");
                containers[id] = Fotobook.book.getSavedPositionParams($this, [prop]);
            });
            Fotobook.containers.changeContainerAttrs(containers);
        },
        action_selectedtotop: function(){
            this._align_selection("top");
        },
        action_selectedtoleft: function(){
            this._align_selection("left");
        },
        action_selectedtobottom: function(){
            this._align_selection("bottom");
        },
        action_selectedtoright: function(){
            this._align_selection("right");
        },
        action_fitquality: function(){
            Fotobook.containers.setContainerOptimalQuality(this.group.attr("data-id"), 10);
        },
        action_setshapebyfoto: function(){
            if(this.element.hasClass('locked')){
                return false;
            }
            Fotobook.containers.setShapeByPhoto(this.containerId, 10);
        },
        action_strokewidth: function (event, ui) {
            if (event.type == "popupclose"){
                return;
            }
            var widget = this,
                cont = widget.element,
                containers = {},
                containerId,
                selector = Fotobook.book.getElementSelector(cont);
            if (event.type == 'slidestop') {
                containerId = cont.attr('data-id');
                containers[containerId] = {
                    'stroke_width': ui.value
                };
                Fotobook.book.setFrameStrokeWidth(selector, ui.value);
                Fotobook.containers.changeContainerAttrs(containers);
            } else if (event.type == 'slide') {
                Fotobook.book.setFrameStrokeWidth(selector, ui.value);
            }
        },
        action_framerx: function (event, ui) {
            if (event.type == "popupclose"){
                return;
            }
            var widget = this,
                cont = widget.element,
                containers = {},
                containerId,
                selector = Fotobook.book.getElementSelector(cont);
            if (event.type == 'slidestop') {
                containerId = cont.attr('data-id');
                containers[containerId] = {
                    'rx': ui.value
                };
                Fotobook.book.setFramerx(selector, ui.value);
                Fotobook.containers.changeContainerAttrs(containers);
            } else if (event.type == 'slide') {
                Fotobook.book.setFramerx(selector, ui.value);
                Fotobook.book.setContrx(selector, ui.value);
            }
        },
        /**
         * Скруглить углы
         * @param event
         * @param ui
         */
        action_contrx: function(event, ui){
            if (event.type == "popupclose") return;
            var widget = this,
                cont = widget.element,
                containers = {},
                containerId,
                selector = Fotobook.book.getElementSelector(cont);
            if(event.type == 'slidestop'){
                containerId = cont.attr('data-id');
                containers[containerId] = {
                    'rx': ui.value
                };
                Fotobook.book.setContrx(selector, ui.value);
                Fotobook.containers.changeContainerAttrs(containers);
            }else if(event.type == 'slide'){
                Fotobook.book.setContrx(selector, ui.value);
            }
        },
        add_remove_shadow: function(add){
            let $cont = this.element,
                containers = {},
                id = $cont.attr('data-id');

            containers[id] = {
                'drop_shadow': {},
            };
            containers[id].drop_shadow[add ? "add" : "remove"] = 1;
            Fotobook.containers.changeContainerAttrs(containers).then(() => {
                this._checkButtons();
                this._updateButtonsShadow();
            }).catch(() => {});
        },
        action_addshadow: function(){
            this.add_remove_shadow(true);
        },
        action_removeshadow: function(){
            this.add_remove_shadow(false);
        },
        action_shadowopacity: function (event, ui) {
            if (event.type == "popupclose"){
                return;
            }
            var widget = this,
                cont = widget.element,
                containers = {},
                containerId,
                selector = Fotobook.book.getElementSelector(cont);
            if (event.type == 'slidestop') {
                containerId = cont.attr('data-id');
                containers[containerId] = {
                    'drop_shadow': {
                        'opacity': ui.value / 100,
                    },
                };
                Fotobook.book.setShadowOpacity(selector, ui.value / 100);
                Fotobook.containers.changeContainerAttrs(containers);
            } else if (event.type == 'slide') {
                Fotobook.book.setShadowOpacity(selector, ui.value / 100);
            }
        },
        action_shadowblur: function (event, ui) {
            if (event.type == "popupclose"){
                return;
            }
            var widget = this,
                cont = widget.element,
                containers = {},
                containerId,
                selector = Fotobook.book.getElementSelector(cont);
            if (event.type == 'slidestop') {
                containerId = cont.attr('data-id');
                containers[containerId] = {
                    'drop_shadow': {
                        'blur': ui.value / 1000,
                    },
                }
                Fotobook.containers.changeContainerAttrs(containers);
                Fotobook.book.setShadowBlur(selector, ui.value / 1000);
            } else if (event.type == 'slide') {
                Fotobook.book.setShadowBlur(selector, ui.value / 1000);
            }
        },
        action_shadowposition: function (event, ui) {
            if (event.type == "popupclose" || event.type == "popupopen"){
                return;
            }
            var widget = this,
                cont = widget.element,
                containers = {},
                containerId,
                selector = Fotobook.book.getElementSelector(cont),
                prop = $(ui.handle).parent().hasClass('shadowposition-x') ? 'dx' : 'dy',
                data = {};
            if (event.type == 'slidestop') {
                containerId = cont.attr('data-id');
                data[prop] = ui.value / 1000;
                containers[containerId] = {
                    'drop_shadow': data,
                };
                Fotobook.containers.changeContainerAttrs(containers);
                Fotobook.book.setShadowPosition(selector, {
                    'prop': 'data-' + prop,
                    'value': ui.value / 1000,
                });
            } else if (event.type == 'slide') {
                Fotobook.book.setShadowPosition(selector, {
                    'prop': 'data-' + prop,
                    'value': ui.value / 1000
                });
            }
        },
        /**
         *
         * @param cls
         * @private
         */
        _flip: function (cls) {
            var id = this.containerId,
                flip = this.element.hasClass(cls) ? 0 : 1,
                params = {};
            params[id] = {};
            params[id][cls] = flip;
            Fotobook.containers.changeContainerAttrs(params);
        },
        action_flipx: function(){
            this._flip("flipx");
        },
        action_flipy: function(){
            this._flip("flipy");
        },

        /**
         * Повернуть фото на угол
         *
         * @param angle
         * @private
         */
        _rotate: function (angle) {
            if (this.edit_mode != this.TYPE_FOTO && this.edit_mode != this.TYPE_FOTOWINDOW) {
                return;
            }

            var widget = this,
                $this = this.element,
                container = $this.closest(".foto-container"),
                image = container.find(".foto-image"),
                imageId = image.attr("data-id");

            if (container.hasClass('empty')) {
                return;
            }

            this.disableButtons(["rotateright", "rotateleft"]);
            container.addClass("ajax-loader");
            Fotobook.fotoManager.rotateImage(angle, [imageId]).then((response) => {
                for (let i = 0, l = response.data.fotos.length; i < l; i++) {
                    let foto = response.data.fotos[i];
                    Fotobook.bottomPanel.fotosTab.updateImageAttrs(foto.id, {
                        "path": foto.path,
                        "preview_path": foto.preview_path,
                        "width": foto.width,
                        "height": foto.height,
                        "version": foto.version
                    });
                }
                Fotobook.book.updateBookFromResponse(response.data);
                Fotobook.qualityCheck.showByFotoId(imageId);
                container.removeClass("ajax-loader");
                widget._checkButtons();
            }).catch(() => null);
        },
        action_dropdown: function(event){
        },
        action_rotateright: function(){
            this._rotate(90);
        },
        action_rotateleft: function(){
            this._rotate(-90);
        },
        /**
         * Restore original attributes
         */
        action_origattrs: function(){
            var ids = [],
                $elements;
            if (this.edit_mode == this.TYPE_BG) {
                $elements = Fotobook.book.getSingleOrSpreadBg(this.element).find(".bg-content")
            } else {
                $elements = this.element;
            }
            $elements.each(function(){
                var $this = $(this),
                    id = parseInt($this.attr("data-id"), 10);
                if (id) {
                    ids.push(id);
                    $this.trigger("mouseover.wizardbook");
                }
            });

            Fotobook.containers.restoreOrigAttrs(ids);
            // перерисовать иконку drug & drop
            // http://bt.web100.com.ua/view.php?id=51038
            setTimeout(function(){
                $(Fotobook.book.book + " .text-container.top-level").trigger('mouseover.wizardbook');
            }, 500);
        },
        action_delframe: function(){
            var params = {};

            params[this.element.closest(".foto-container").attr("data-id")] = {
                "frame_id": 0,
            };
            Fotobook.containers.changeContainerAttrs(params);
        },
        /**
         * Удалить маску с фото
         */
        action_delmask: function(){
            var containers = {};
            if (this.edit_mode != this.TYPE_BG) {

                var id = parseInt(this.element.closest(".page-container").attr("data-id"), 10);
                containers[id] = {
                    "mask_id": 0,
                    "rx": 0,
                };
            } else {
                Fotobook.book.getSingleOrSpreadBg(this.element).find(".bg-content").each(function () {
                    containers[parseInt(this.getAttribute("data-id"), 10)] = {
                        "mask_id": 0,
                        "rx": 0,
                    };
                });
            }
            Fotobook.containers.changeContainerAttrs(containers);

            // cбросить в нулевое значение слайдера скругления углов
            $.each( $("div.input-range-slider"), function(){
                if($(this).data('role') === 'contrx'){
                    $(this).slider('value', 0);
                    $(this).find('span').attr('title', 0);
                }
            } );

        },
        action_delfoto: function(){
            if (this.edit_mode == this.TYPE_BG) {
                var bgs = Fotobook.book.getSingleOrSpreadBg(this.element).find(".bg-content"),
                    containers = {};
                bgs.each(function(){
                    containers[parseInt(this.getAttribute("data-id"), 10)] = {
                        "foto_id": 0,
                    };
                });
                Fotobook.containers.changeContainerAttrs(containers);
            } else {
                Fotobook.containers.delFoto.call(this.element);
            }
        },
        /**
         * Удалить контейнер
         */
        action_deletecont: function(){
            var containers = this.element;
            if (this.edit_mode === this.TYPE_SELECTION) {
                containers = $(".top-level.selected:not(.locked)");
            }
            Fotobook.book.removeContainerConfirmation(containers).then(() => {
                setTimeout(() => {
                    Fotobook.book.removeContainersSend(containers);
                }, 0);
            });
        },
        action_popupclose: function (button) {
            $(button).closest(".tb-popup").removeClass("active");
        },
        action_close: function(){
            this.destroy();
        },
        action_cancel: function(){
            this.destroy();
        },
        /** Установить отображение дней в календаре */
        action_dayNamesPosition: function(event){
            Fotobook.containers.calendar.editor.changeDayNamesPosition(this.element, $(event).hasClass("active"));
        },
        /** Установить отображение дней в календаре */
        action_headerMode: function(event){
            Fotobook.containers.calendar.changeAttribute(this.element, "month_name_position", $(event).data("value"));
        },
        action_calendarDate: function(event) {
            if (event.type == "popupclose"){
                return;
            }
            var $button = $(event);

            if ($button.hasClass("tb-dropdown-row")) {

                var $popup = $button.closest('.tb-popup-window'),
                    month = ('0'+$popup.find('select[name="month"]').val()).slice(-2),
                    year = $popup.find('select[name="year"]').val();

                Fotobook.containers.calendar.editor.setCalendarDate(this.element, month, year);
            }
        },

        /** показывать/скрывать дни cоседних месяцев */
        action_externalDaysVisibility: function (actionButton) {
            var container = {},
                pageContainer = $(this.element),
                pageContainerId = $(this.element).data('id'),
                currentColor = pageContainer.attr('data-numbers_color_external');

            if('transparent' === currentColor) {
                currentColor = 'rgba(211, 211, 211, 0.5)'; // lightgrey
            } else {
                currentColor = 'transparent';
            }

            container[pageContainerId] = {};
            container[pageContainerId]["calendar"] = {};

            container[pageContainerId]["calendar"]["numbers_color_external"] = currentColor;
            Fotobook.containers.changeContainerAttrs(container);
        },

        commitSpine: function(){
            this.saveSpine = true;// todo избавиться, реализовать понятнее
            this.destroy();
        },
        /** Сохранить содержимое текстового контейнера */
        saveTextContainer(force = false) {
            const $element = this.element;
            const id = Number($element.attr('data-id'));
            const newContent = this._getSaveContent();
            const originalContent = this.originalCaption;

            const params = {
                [id]: {
                    caption: {
                        content: newContent,
                    },
                    text_content_ratio: Fotobook.book.getTextContentRatio($element),
                },
            };

            if (!force && newContent === this.lastSavedTextContent) {
                // add div to prevent content parsing error
                if ($(`<div>${newContent}</div>`).text().trim() === '') {
                    Fotobook.book.markEmptyCaption(this.element);
                }
                return;
            }

            Fotobook.containers.changeContainerAttrs(params)
                .then(() => {
                    this.lastSavedTextContent = newContent;
                    Fotobook.book.updateCaptionContent(id, newContent);
                }).catch(() => {
                    Fotobook.book.updateCaptionContent(id, originalContent);
                });
        },

        destroyTextContainer: function(){
            if (!this._isTextEditor()) {
                return;
            }

            this._clearContentEditable();
            if (this.edit_mode == this.TYPE_SPINE) {
                // todo сделать как-то более понятно
                if (this.saveSpine) {
                    this.saveTextContainer();
                } else {
                    Fotobook.book.updateCaptionContent(this.containerId, this.originalCaption);
                }
                this.element.trigger(Fotobook.events.RECALC_CONTAINER);
            } else if (!this.element.closest(".page-container[data-deleted]").length) {
                this.saveTextContainer();
            }
        },

        _destroy: function(){
            var widget = this;

            // вначале удаляем тулбар, чтобы отработали деструкторы всех виджетов
            this.toolbar.remove();
            this.richDD.obj = null;

            this.destroyTextContainer();

            if (this.withQtip && this.element.data("qtip")) {
                this.element.data("qtip").disable(false);
            }
            if (this.edit_mode == this.TYPE_RICHTEXT) {
                this.element.find('.text-content').html(this.redactorArea.redactor('code.get'));
                this.redactorArea.redactor("core.destroy");
                this.redactorArea.remove();
                $(".redactor-dropdown").each(function(){
                    if ($(this).data("fotobook-containerEditor-toolbar") == widget.toolbar) {
                        $(this).remove();
                    }
                });
            }
            if (!this._isSelection()) {
                if (this.group.data("ui-resizable")) {
                    this.group.resizable("destroy");
                }
                this.group.find(".ui-rotatable-handle,.ui-resizable-handle").remove();

                if (this._isBg()) {
                    var wrapper = this.element.closest(".pages-wrapper");
                    wrapper.find(".bg").removeClass("editing");
                } else {
                    this.element.removeClass("editing");
                    if (!this.group.find(".editing").length) {
                        this.group.add(this.group.closest(".cont-wrapper")).removeClass("editing");
                        if (!$(Fotobook.book.book).find(".editing").length) {
                            $(Fotobook.main).removeClass("editing");
                        }
                    }
                }

                if (this._isSpine()) {
                    $("#spineEditor").remove();
                }
            } else {
                $(".page-container.selected").removeClass("selected");
            }

            this._super();
        },

        /** применить формат текущего календаря для всех */
        action_applyCalendarFormatsToAll: function (button) {
            const id = $(this.element).data('id');
            Fotobook.containers.applyCalendarFormatsToAll(id);
            $(button).closest(".tb-popup").removeClass("active");
        },
    });


// Здесь обновляется положение тулбара по перемещению контейнера
// Также здесь ловится поворот. По-хорошему, надо поворот сделать нормальным виджетом и ловить его события
    $(window)
    .on("update-container-toolbar", function(e){
        var $target = $(e.target);
        if ($target.length) {
            var editors = $target.closest(".page-container,.bg");
            editors.add(editors.find(".page-container.editing, .bg-content.editing")).each(function(){
                var widget = $(this).data("fotobook-containerEditor");
                if (widget) {
                    widget.updateToolbarPosition();
                }
            });
        }
    })
    .on("resize", function(e){

        if (e.target instanceof HTMLElement){
            return;
        }

        $(":fotobook-containerEditor").each(function(){
            var widget = $(this).data("fotobook-containerEditor");
            setTimeout(function(){
                widget.updateToolbarPosition();
            }, 0);
        });

    });


    $(document)
    // ловим скроллирование увеличенного редактора книги
    .on("scroll", ".book-wrapper", function (e) {
        $(this).find(".editing").trigger("update-container-toolbar");
    })
        /** двойной клик по фону страницы */
    .on('dblclick', '#book .bg-content', (e) => {
        if (Fotobook.store.getters['OnlineEditor/editMode'].code === Fotobook.EditModeCode.INSTANT) {
            return;
        }
        const $target = $(e.target);
        const $element = $target.closest('.bg-content');
        if ($element.hasClass('ajax-loader')) {
            return;
        }
        if($element.length && !$element.data('fotobook-containerEditor')){
           $element.containerEditor();
        }
    })
    .on("keyup", ".text-content, .redactor-editor", function(e){
        var $this = $(this),
            widget = $this.closest(".text-container").data("fotobook-containerEditor") || $("#book .spine").data("fotobook-containerEditor");

        if (widget) {
            widget.toggleButtons("clear", widget.checkEnableClearButton);
            widget._copySpine();
        }

        // http://bt.web100.com.ua/view.php?id=51046
        // Передвигать автоматически горизонтальную/вертикальную прокрутку при вводе текста если он выходит за пределы видимой области (до конца области редактирования).
        // в хроме не всегда jScrollPаne переинициализируется автоматически, делаем вручную
        var scroll = $('.book-wrapper').data('jsp');
        if (scroll){
            scroll.scrollToElement($this, true);
        }

    })

    .on("click keyup", ".text-content[contenteditable]", function (event) {
        var range = rangy.getSelection().getAllRanges();
        for (var i = 0, l = range.length; i < l; i++) {
            if ($(range[i].commonAncestorContainer.parentNode).hasClass("text-content")) {
                // $(event.target).data("rangy", range[i]);
            }
        }
    })
    .on("focus", ".text-content[contenteditable]", function (event) {
        var range = $(event.target).data("rangy");
        // rangy.getSelection().setSingleRange(range);
    })
    .on('click', '.text-container.editing .caption', function (event) {
        const $target = $(event.target);
        if ($target.closest('[contenteditable]').length) {
            return;
        }
        // setTimeout(() => {
            $(this).find('[contenteditable]').focus();
        // });
    })
;

    $(document).on(Fotobook.events.TEXT_CONTAINER_CHANGED, function(e){
        var $container = $(e.target).closest(".page-container.editing"),
            widget = $container.data("fotobook-containerEditor");

        if (!widget) {
            return;
        }
        widget._closeOpenLists();
        widget.checkTextContainerHeight();
    });

    //todo Рассмотреть вариант проверки какой именно редактор запущен
    $(document).on(Fotobook.events.ORIGINAL_UPLOAD_END, function(event, data) {
        $(":fotobook-containerEditor").each(function() {
            var widget = $(this).data("fotobook-containerEditor");
            widget._checkButtons();
        });
    });

// Затычка для феерического бага вебкита: после окончания ресайза если курсор находится за пределами
// элемента, который ресайзим, событие срабатывает на каком-то из предков (не на прямом предке),
// над которым в момент отпускания кнопки мыши был курсор. Если существует лучший способ, нужно этот
// кусок кода заменить
// Баг: http://bt.web100.com.ua/view.php?id=43910 и подобные проявления
    function fixChromeMouseup() {
        if (!$.browser.webkit){
            return;
        }

        $("html").one("click.fotobook_editors_noclick", function(e){
            e.preventDefault();
            e.stopPropagation();
        });
        setTimeout(function(){
            $("html").off(".fotobook_editors_noclick");
        }, 300);
    }
    if ($.browser.webkit){
        // Вебкит при выделении текста, если курсор находится за пределами контейнера
        // закрывает редактор текстов (из разряда феерических багов)
        // надо ли проверять на вебкит?
        (function(){
            var selectionActive = false;
            $(document).on("mousedown", "[contenteditable]", function(){
                selectionActive = true;
            });
            $(document).on("mouseup", function(e){
                if (selectionActive) {
                    selectionActive = false;
                    fixChromeMouseup();
                }
            });
        })();

        // Затычка для вебкита:
        // При удалении отступа строчка оборачивается в span со стилями
        $(document).on("keyup", '.caption[data-type="' + Fotobook.CaptionType.PLAIN + '"] .text-content[contenteditable]', function(e){
            var span = $(this).find("span");
            if (span && span.attr("style")) {
                span.contents().unwrap();
            }
        });
    }


    if (!("_fotobookResizable" in $.fn)){
        $.fn._fotobookResizable = function(){
            return this.each(function(){
                const $this = $(this);
                //отключение ресайза для фотонакладки
                if ($this.hasClass(Fotobook.CONT_SUBTYPE_FOTOWINDOW_CLASS)) {
                    return;
                }
                const id = $(this).attr('data-id');
                const snapSelector = `${Fotobook.book.book} .drag-align-lines:not(.drag-${id})`;
                $(this).resizable({
                    snapTolerance: 10,
                    snap: snapSelector,
                    "aspectRatio": true,
                    "handles": "all",
                    "zIndex": Fotobook.book.zindex.container_max + 2,
                    "autoHide": false,
                    "start": function (event, ui) {
                        $("html").addClass("container-resizing");
                        var fs = parseFloat(ui.helper.css("font-size"));
                        ui.helper.css({
                            "top": parseFloat(ui.helper.css("top")) / fs + "em",
                            "left": parseFloat(ui.helper.css("left")) / fs + "em",
                        });
                        ui.element.attr({
                            'data-initial_width': $(ui.element).width(),
                            'data-initial_height': $(ui.element).height(),
                        });
                        Fotobook.book.backupInitialCoordinates(ui.helper, ["top", "left", "width", "height"]);
                        $(event.originalEvent.originalEvent.target).addClass("active-handle");

                        // https://jira.web100.com.ua/browse/FOT-4625
                        // не удалось реализовать требуемое поведение - отключено прилипание
                        // при ресайзе в определенных направлениях
                        if (['e', 'se', 's'].includes($(ui.helper).data('uiResizable').axis)) {
                            ui.helper.resizable('option', 'snap', snapSelector);
                        } else {
                            ui.helper.resizable('option', 'snap', false);
                        }
                    },
                    "resize": function (event, ui) {
                        var $page = ui.element.closest(".book-page"),
                            k = Fotobook.book.getPagePixelK($page);
                        if (ui.element.hasClass("text-container")) {
                            ui.element.resizable("option", "minHeight", Fotobook.book.getTextContainerMinHeight(ui.element));
                        }
                        ui.element.attr({
                            "data-width"  : k*parseFloat(ui.element[0].style.width),
                            "data-height" : k*parseFloat(ui.element[0].style.height),
                        });
                        Fotobook.book.recalcContainer.call(ui.element);
                        ui.element.trigger("update-container-toolbar");
                    },
                    "stop": function (event, ui) {
                        if (ui.element.hasClass("text-container")) {
                            ui.element.resizable("option", "minHeight", Fotobook.book.getTextContainerMinHeight(ui.element));
                            ui.element.data("ui-resizable")._mouseDrag(event);
                        }
                        $("html").removeClass("container-resizing");
                        $(".active-handle").removeClass("active-handle");
                        fixChromeMouseup();

                        // также при ресайзе делаем рекалькуляцию шрифтов для календарей
                        let additionalParams = {};
                        if (Fotobook.containers.isCalendar(ui.element)) {
                            additionalParams = {
                                calendar: Fotobook.containers.calendar.calculateCalendarFontSizes(ui.element),
                            };
                        }

                        const affectedCoords = ['top', 'left', 'width', 'height'];
                        Fotobook.book.saveContainerPositionFotoOnBg($(this), affectedCoords, additionalParams);
                        Fotobook.draggable.buildCenterPageLines($(this));
                    }
                });
            });
        };
    }

    if (!("_fotobookRotatable" in $.fn)){
        $.fn._fotobookRotatable = function(){
            return this.each(function(){
                const $this = $(this);
                //отключение поворота для фотонакладки
                if ($this.hasClass(Fotobook.CONT_SUBTYPE_FOTOWINDOW_CLASS)) {
                    return;
                }
                $this.rotatable({
                    start() {
                        this.addClass("ui-rotatable-rotating");
                        Fotobook.book.backupInitialCoordinates(this, ["angle"]);
                    },
                    rotate(event, ui) {
                        $this.css(Fotobook.book.getContainerAngleVars(ui.angle));
                        $this.css('transform', '');
                        this.trigger("update-container-toolbar");
                        Fotobook.book.recalcContainer.call(this);
                    },
                    stop(event, ui) {
                        fixChromeMouseup();
                        this.removeClass("ui-rotatable-rotating");
                        Fotobook.book.saveContainerPosition(this, ["angle"]);
                    }
                });
            });
        };
    }
})(jQuery);
